import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { ToastContainer, toast } from "react-toastify";
import { BASE_URL, TESTING_URL_actual } from "../../config/axios";
import { handleErrorToast, customSortByKey, formatRoundoffComplete } from "../CustomFunctions";
import { AddwithWhiteCircle, DeleteDustbin, CloudUpload, UpdatePencil, Filter, AddwithBlueCircle, Attachment, DownloadIcon, UploadIcon, Office, Eye, DropdownArrowOption } from "../AllSvg";
import usePermission from "../../config/permissions";
import Select from "react-select";
import * as XLSX from 'xlsx';


const UploadSalaryDataBulk = ({ id, getPayrunlist }) => {
  const [show, setShow] = useState(false);
  const handleShow = () => {
    getAllEmployeeData();
    setShow(true)
  };
  const { SUB_COMPANIES } = usePermission();
  const [toggleCompany, setToggleCompany] = useState('null');

  const [fileName, setFileName] = useState("");
  const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
  const [docErrors, setDocErrors] = useState({});
  const [docInputState, setDocInputState] = useState({});

  const [jsonData, setJsonData] = useState(null);


  const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);
  const [allEmployeeList, setAllEmployeeList] = useState([]);
  const [buffer1, setBuffering1] = useState(true);
  const [buffer2, setBuffering2] = useState(true);

  useEffect(() => {
    getAllEmployeeData()
    getAllSalaryRelatedData();
  }, [toggleCompany]);



  const getAllSalaryRelatedData = async (emp_code) => {
    setBuffering1(true); //buffering logic
    try {
      const headings = await axios.get(`${BASE_URL}/siteproject/salaryHeadingbysubcompany/${toggleCompany}/`);
      setSalaryStructureHeadings(headings.data);

    } catch (err) {
      console.error("Error fetching salary data", err);
    } finally {
      setBuffering1(false); //buffering logic
    }
  };

  let getAllEmployeeData = async () => {
    setBuffering2(true); //buffering logic
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/employeefilterbysubcompany/${toggleCompany}/`
      );
      const sortedList = customSortByKey(res.data, "emp_code");

      setAllEmployeeList(sortedList);
      // setAllEmployeeList(res.data);
    } catch (err) {
      //toast Logic
      handleErrorToast(err);

    } finally {
      setBuffering2(false); //buffering logic
    }
  };

  const bulktableRef = useRef(null);
  const handleDownload = () => {
    const table = bulktableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: "Salary Sheet" });
    const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

    const blob = new Blob([s2ab(wbout)], {
      type: "application/vnd.ms-excel",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Salary Sheet Format.xls";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };


  const handleClose = () => {
    setFileName("")
    setExcelJson(null)
    setDocErrors({})
    setShow(false)
  };

  // const handleFileUpload = (event) => {
  //   const file = event.target.files[0];
  //   console.log(file)
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const data = new Uint8Array(e.target.result);

  //       const workbook = XLSX.read(data, { type: 'array' });

  //       console.log("workbook")
  //       console.log(workbook)

  //       // Assuming the sheet with attendance data is named "Attendance"
  //       const worksheet = workbook.Sheets['Attendance Sheet'];

  //       const rawData = XLSX.utils.sheet_to_json(worksheet);
  //       console.log("rawData")
  //       console.log(rawData)
  //       // Transform rawData into the required format for uploading

  //       setJsonData(rawData);
  //     };
  //     reader.readAsArrayBuffer(file);
  //     setFileName(file.name);
  //   }
  // };

  const readExcel = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0]; // Use the first sheet
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

      const headers = json[0];
      const rows = json.slice(1);



      // Create a formatted JSON object based on headers and row values
      const formattedJson = rows.map((row) => {
        const obj = {};
        headers.forEach((header, index) => {
          obj[header] = row[index] !== undefined ? row[index] : null;
        });
        return obj;
      });


      // Ensure the input to checkForDuplicates is an array

      // Set the formatted JSON data to state
      setExcelJson(formattedJson);
    };
    reader.readAsArrayBuffer(file);

  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check for valid file type
      const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
      if (!validFileTypes.includes(file.type)) {
        setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
        setFileName("");
        return;
      }

      setFileName(file.name);
      readExcel(file); // Convert the file to JSON
    } else {
      setFileName("");
    }
  };

  const handleUpload = async () => {

    if (excelJson) {

      const loadingToastId = toast.loading("Uploading: Please wait...");
      try {
        const res = await axios.post(`${BASE_URL}/siteproject/bulkcustomdeductionupload/`, excelJson);
        if (res.status === 200) {

          handleClose();
          toast.dismiss(loadingToastId);
          toast.success("Salary Data uploaded successfully.");

        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to add data!");
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    } else {
      setDocErrors({ document_file: "Please upload a valid Excel file." });
    }
  };

  const [loading, setLoading] = useState(false); //loading logic
  // const handleSubmit = async () => {
  //   setLoading(true); //loading logic
  //   const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
  //   if (!jsonData) {
  //     alert("Please upload an Excel file first!");
  //     return;
  //   }
  //   try {
  //     const response = await axios.post(`${BASE_URL}/siteproject/bulkcustomdeductionupload/`, jsonData);
  //     // alert('Attendance uploaded successfully!');
  //     toast.success('Attendance uploaded successfully!');
  //     await getPayrunlist()
  //     handleClose()
  //   } catch (error) {
  //     console.error('Error uploading attendance:', error);
  //     toast.err('Error uploading Slary Structures.');
  //     // alert('Error uploading Slary Structures.');
  //   } finally {
  //     setLoading(false); //loading logic
  //     toast.dismiss(loadingToastId);
  //   }
  // };




  const [selectedIndex, setSelectedIndex] = useState(-1);

  const handleClick = (index) => {
    setSelectedIndex(index);
  };

  const tableRef = useRef(null);





  console.log(salaryStructureHeadings)

  return (
    <>
      <button
        title="Bulk Upload Salary Data"
        className="model-button font-weight500 model-button-print"
        onClick={handleShow}
        style={{ margin: "2px" }}
      >
        <UploadIcon />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model">
        <Modal.Header
          closeButton
          className="task-Tab-heading font-weight500 font-size-heading ">

          <Modal.Title>Upload Bulk Salary Data in Format:</Modal.Title>

          <div className="">
            <div className="">

              {toggleCompany !== "null" ?
                <button onClick={handleDownload} className="model-button-download model-button font-weight500 field-cont-div" style={{ marginLeft: "35vw" }}>
                  <DownloadIcon />
                  {"  "} Format
                </button> : null}
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>


          <div className="table-css-white-background" style={{ display: "none" }}>
            <table
              ref={bulktableRef}
              id="my-table"
              style={{
                borderColor: "#323232",
                borderRadius: "5px",
                padding: "0px 5px",
                borderWidth: "1px",
                // marginLeft: "10px",
                // zoom: "70%",
              }}
            >
              <thead                            >
                <tr>
                  <th className="summary-excel-tab br-5">emp_code</th>
                  <th className="summary-excel-tab br-5">name</th>
                  {salaryStructureHeadings.sort((a, b) => a.sorting_var - b.sorting_var).map((heading) => (
                    <React.Fragment key={heading.id}>
                      <th>{heading.title} fixed_amount</th>
                      <th>{heading.title} percentage</th>
                      <th>{heading.title} percentage_of</th>
                    </React.Fragment>
                  ))}
                </tr>
              </thead>
              {
                // buffer ? <div className="spinner"></div> :
                <tbody>
                  {allEmployeeList
                    .sort((a, b) => a.emp_code - b.emp_code)
                    .map((data, index) => {
                      const inactivename = data.employee_status === "inactive" ? "#ff1212" : "black";
                      return (
                        <>
                          <tr
                            style={{
                              backgroundColor:
                                index === selectedIndex ? "yellow" : "white",
                              color: inactivename,
                            }}
                            onClick={() => handleClick(index)}
                          >
                            <td className="summary-excel-tab br-5">{data.emp_code}</td>
                            <td className="summary-excel-tab br-5">{data.name}</td>
                          </tr>
                        </>
                      );
                    })}
                </tbody>
              }
            </table>

          </div>

          <div className="bulk-salary ">
            <div>

              <label htmlFor="company.title" className="company-labels font-weight500 font-size-heading">
                Select Company
              </label>
              <div className="table-searchh dropdown-container">
                <Office />
                <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                  <option value="null">Select SubCompany</option>
                  {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};

                </select>
              </div>
            </div>



            <div className="flex-column field-cont-div">
              <label htmlFor="document_file" className="form-labels font-weight500 font-size-heading">
                Upload File
              </label>
              <label
                htmlFor="document_file"
                className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                  }`}
              >
                <div className={`align-center pdf-input  ${docErrors.document_file ? 'error' : ''}`}>
                  <Attachment />
                </div>
              </label>
              <input
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileChange}
                id="document_file"
                name="document_file"
                className="file-inputs align-center"
                style={{ display: "none", position: "relative" }} />
              {fileName && <p className="file-name align-center">{fileName}</p>}
              <br />
              {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
            </div>
          </div>



          <div className="button-models">
            <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
              Cancel
            </button>
            <button className="model-button-download model-button font-weight500" onClick={handleUpload} disabled={loading}>
              <UploadIcon />
              {"  "} {loading ? "Uploading..." : "Upload"}
            </button>
          </div>
          <ToastContainer position="top-center" autoClose={10000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

        </Modal.Body>
      </Modal>
    </>
  );
};


const DownloadSalaryBulkFormat = () => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    // toast.warning("Please Select Subcompany First");
    // getAllSalaryRelatedData();
    // getAllEmployeeData();
    setShow(true)
  };
  const handleClose = () => {
    setShow(false)
  };

  const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();
  const [toggleCompany, setToggleCompany] = useState('null');


  const [allEmployeeList, setAllEmployeeList] = useState([]);
  const [salaryDeductionPolicies, setSalaryDeductionPolicies] = useState([]);
  const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);
  const [selectedPolicy, setSelectedPolicy] = useState("null");
  const [selectedPolicyData, setSelectedPolicyData] = useState({});
  const [selectedPolicyDeductions, setSelectedPolicyDeductions] = useState([]);

  const [showEmpData, setShowEmpData] = useState(false);
  const [buffer1, setBuffering1] = useState(true);
  const [buffer2, setBuffering2] = useState(true);


  useEffect(() => {
    getAllSalaryRelatedData();
    getAllEmployeeData();
  }, [toggleCompany]);

  const getAllSalaryRelatedData = async (emp_code) => {
    setBuffering1(true); //buffering logic
    try {
      const headings = await axios.get(`${BASE_URL}/siteproject/salaryHeadingbysubcompany/${toggleCompany}/`);
      setSalaryStructureHeadings(headings.data);
      const policies = await axios.get(`${BASE_URL}/siteproject/salarypolicybysubcompany/${toggleCompany}/`);
      setSalaryDeductionPolicies(policies.data);
    } catch (err) {
      console.error("Error fetching salary data", err);
    } finally {
      setBuffering1(false); //buffering logic
    }
  };



  const getAllEmployeeData = async () => {
    setBuffering2(true); //buffering logic
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/employeefilterbysubcompany/${toggleCompany}/`
      );
      // const ress = await axios.get(`${TESTING_URL_actual}/siteproject/employee/`);
      const sortedList = customSortByKey(res.data, "emp_code");
      setAllEmployeeList(sortedList);
    } catch (err) {
      // handleErrorToast(err);
      console.error("Error fetching Employee data", err);

    } finally {
      setBuffering2(false); //buffering logic
    }
  };

  const handlePolicySelect = (e) => {
    const { value } = e.target;
    setSelectedPolicy(value);

    if (value === "null") {
      setSelectedPolicyDeductions([]);
      return;
    }

    const selected = salaryDeductionPolicies.find(
      (format) => String(format.id) === String(value)
    );
    setSelectedPolicyData(selected);

    if (selected) {
      const transformedDeductions = selected.custom_deductions?.map((deduction) => ({
        ...deduction,
        // percentage_of: deduction.percentage_of.map((item) => ({
        //     id: item.name, // switch from item.id to item.name
        //     name: item.name_title || item.name, // fallback to name if title is missing
        //     title: item.name_title, // fallback to name if title is missing
        // })),
      }));
      setSelectedPolicyDeductions(transformedDeductions);
    }
  };


  const bulkformattableRef = useRef(null);
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };
  const handleDownload = () => {
    const table = bulkformattableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: "Salary Format" });
    const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

    const blob = new Blob([s2ab(wbout)], {
      type: "application/vnd.ms-excel",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Salary Format-${selectedPolicyData.policy_name}-${selectedPolicyData.sub_company_title}.xls`;
    a.click();
    window.URL.revokeObjectURL(url);
  };




  const [loading, setLoading] = useState(false); //loading logic
  // console.log("selectedPolicyDeductions;", selectedPolicyDeductions)

  const orderedSalaryStructureHeadings = (() => {
    const matchingHeadings = [];
    const nonMatchingHeadings = [];

    salaryStructureHeadings.forEach((heading) => {
      const match = selectedPolicyDeductions.find(d => d.name === heading.id);
      if (match) {
        matchingHeadings.push({ ...heading, match_sort: match.sorting_var || 0 });
      } else {
        nonMatchingHeadings.push(heading);
      }
    });

    matchingHeadings.sort((a, b) => a.match_sort - b.match_sort);
    nonMatchingHeadings.sort((a, b) => a.sorting_var - b.sorting_var);

    return [...matchingHeadings, ...nonMatchingHeadings];
  })();



  return (
    <>
      <button
        title="Bulk Salary Format Download"
        className="model-button-download model-button font-weight500"
        onClick={handleShow}
        style={{ margin: "2px" }}
      >
        <DownloadIcon />
        {"  "} Format
      </button>



      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="task-Tab-heading font-weight500    font-size-heading ">
          <Modal.Title>Download Bulk Salary Data Format:</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className="form-flex-wrap">
            {<div>
              <label htmlFor="company" className="form-labels">
                Select Company
              </label>
              <div className="table-searchh dropdown-container">
                <Office />
                <select onChange={(e) => setToggleCompany(e.target.value)} value={toggleCompany} className="dropdown font-size-subheading  ">
                  <option value="null">Select SubCompany</option>
                  {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                </select>
              </div>
            </div>}

            <div>
              <label htmlFor="salary_policy" className="form-labels">
                Select Salary Structure Format {selectedPolicyData !== "null" && <ViewSalaryPolicyFormatDeductions i={selectedPolicyData} />}
              </label>
              <div className="table-searchh dropdown-container">
                {buffer1 ? <div className="spinner-vsmall"></div> : <Filter />}
                <select
                  value={selectedPolicy}
                  onChange={handlePolicySelect}
                  className="dropdown font-size-subheading"
                >
                  <option value="null">Select Statuary Deduction Policy</option>
                  {salaryDeductionPolicies?.map((i) => (
                    <option key={i.id} value={i.id}>{i.policy_name}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="flex-row">
              <label className="form-labels">
                With Employee {showEmpData ? "Shown" : "Hidden"} : {" "}
              </label>
              <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
              <div className="checkbox-toggle">
                <input
                  type="checkbox"
                  id="toggle-employees"
                  name="show_emp_data"
                  checked={showEmpData}
                  onChange={() => setShowEmpData(!showEmpData)}
                />
                <label htmlFor="toggle-employees"></label>
              </div>
            </div>
          </div>


          {/* Downloading Format */}
          <h4>Preview Format Excel</h4>
          <div className="scroll-container-table" style={{ minHeight: '25vh', maxHeight: '50vh', overflowY: 'auto' }}>
            <table
              className="scrollfix-table-css"
              ref={bulkformattableRef}
              id="my-table"
              style={{
                borderColor: "#323232",
                borderRadius: "5px",
                padding: "0px 5px",
                borderWidth: "1px",
              }}
            >
              <thead>
                <tr className="custom-table-head-tr">
                  <th className="summary-excel-tab br-5">emp_code</th>
                  <th className="summary-excel-tab br-5">name</th>
                  {
                    // salaryStructureHeadings.sort((a, b) => a.sorting_var - b.sorting_var)
                    orderedSalaryStructureHeadings
                      .map((heading) => (
                        <React.Fragment key={heading.id}>
                          <th className="summary-excel-tab br-5">{heading.title} fixed_amount</th>
                          <th className="summary-excel-tab br-5">{heading.title} percentage</th>
                          <th className="summary-excel-tab br-5">{heading.title} percentage_of</th>
                        </React.Fragment>
                      ))}
                </tr>
              </thead>
              <tbody>
                {showEmpData ? (
                  buffer2 ?
                    <div className="form-loader">
                      <div className="bar-loader"></div>
                    </div>
                    :
                    allEmployeeList
                      .sort((a, b) => a.emp_code - b.emp_code)
                      .map((data, index) => {
                        const inactivename = data.employee_status === "inactive" ? "#ff1212" : "black";
                        return (
                          <tr style={{ color: inactivename }} key={index}>
                            <td className="summary-excel-tab br-5">{data.emp_code}</td>
                            <td className="summary-excel-tab br-5">{data.name}</td>
                            {
                              // salaryStructureHeadings.sort((a, b) => a.sorting_var - b.sorting_var)
                              orderedSalaryStructureHeadings
                                .map((heading) => {
                                  const matchingData = selectedPolicyDeductions.find(
                                    (format) => format.name === heading.id
                                  );
                                  return (
                                    <React.Fragment key={heading.id}>
                                      <td className="summary-excel-tab br-5">
                                        {matchingData?.fixed_amount || ''}
                                      </td>
                                      <td className="summary-excel-tab br-5">
                                        {matchingData?.percentage || ''}
                                      </td>
                                      <td className="summary-excel-tab br-5">
                                        {matchingData?.percentage_of?.length > 0
                                          ? matchingData?.percentage_of.map(item => item.name_title).join(", ")
                                          : ''}
                                      </td>
                                    </React.Fragment>
                                  )
                                })}
                          </tr>
                        );
                      })
                ) : (
                  <tr>
                    <td className="summary-excel-tab br-5">[emp_code]</td>
                    <td className="summary-excel-tab br-5">[name]</td>
                    {
                      // salaryStructureHeadings.sort((a, b) => a.sorting_var - b.sorting_var)
                      orderedSalaryStructureHeadings
                        .map((heading) => {
                          const matchingData = selectedPolicyDeductions.find(
                            (format) => format.name === heading.id
                          );
                          return (
                            <React.Fragment key={heading.id}>
                              <td className="summary-excel-tab br-5">
                                {matchingData?.fixed_amount || ''}
                              </td>
                              <td className="summary-excel-tab br-5">
                                {matchingData?.percentage || ''}
                              </td>
                              <td className="summary-excel-tab br-5">
                                {matchingData?.percentage_of?.length > 0
                                  ? matchingData?.percentage_of.map(item => item.name_title).join(", ")
                                  : ''}
                              </td>
                            </React.Fragment>
                          )
                        })}
                  </tr>
                )}
              </tbody>
            </table>
          </div>


          <div className="button-models">
            <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
              Cancel
            </button>
            <button onClick={handleDownload} className="model-button-download model-button font-weight500" style={{ marginLeft: "35vw" }}>
              <DownloadIcon />
              {"  "} Format
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer position="top-center" autoClose={10000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};

const UpdateSalaryDataBulk = ({ id, getPayrunlist }) => {
  const [show, setShow] = useState(false);

  const handleShow = () => {
    // toast.warning("Please Select Subcompany First");
    getAllSalaryRelatedData();
    getAllEmployeeData();
    setShow(true)
  };
  const handleClose = () => {
    setFileName("")
    setExcelJson(null)
    setJsonData(null);
    setDocInputState({});
    setDocErrors({})
    setShow(false)
  };

  const { SUB_COMPANIES } = usePermission();
  const [toggleCompany, setToggleCompany] = useState('null');


  const [fileName, setFileName] = useState("");
  const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
  const [docErrors, setDocErrors] = useState({});
  const [docInputState, setDocInputState] = useState({});

  const [jsonData, setJsonData] = useState(null);

  const [allEmployeeList, setAllEmployeeList] = useState([]);
  const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);

  const [buffer1, setBuffering1] = useState(true);
  const [buffer2, setBuffering2] = useState(true);


  const getAllSalaryRelatedData = async (emp_code) => {
    setBuffering1(true); //buffering logic
    try {
      const headings = await axios.get(`${BASE_URL}/siteproject/salaryHeadingbysubcompany/${toggleCompany}/`);
      setSalaryStructureHeadings(headings.data);

    } catch (err) {
      console.error("Error fetching salary data", err);
    } finally {
      setBuffering1(false); //buffering logic
    }
  };



  const getAllEmployeeData = async () => {
    setBuffering2(true); //buffering logic
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/employeefilterbysubcompany/${toggleCompany}/`
      );

      const sortedList = customSortByKey(res.data, "emp_code");
      setAllEmployeeList(sortedList);
    } catch (err) {
      handleErrorToast(err);
      console.error("Error fetching Employee data", err);

    } finally {
      setBuffering2(false); //buffering logic
    }
  };


  const bulktableRef = useRef(null);

  const handleFileUploadToJson = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Get the first sheet
        const sheetName = workbook.SheetNames[0];
        // const worksheet = workbook.Sheets[sheetName];
        const worksheet = workbook.Sheets['Salary Format'];

        // Convert to JSON with header row
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        if (jsonData.length < 2) {
          toast.error("Excel file is empty or has no data");
          return;
        }

        // Extract headers (first row)
        const headers = jsonData[0];

        // Process data rows (skip header row)
        const processedData = jsonData.slice(1).map(row => {
          const rowData = {};
          headers.forEach((header, index) => {
            rowData[header] = row[index] !== undefined ? row[index] : null;
          });
          return rowData;
        });

        console.log("processedData")
        console.log(processedData)

        // Extract component names in original column order
        const componentNames = [];
        const seenComponents = new Set();

        headers.forEach(header => {
          if (header === 'emp_code' || header === 'name') return;

          // Extract base component name (remove suffix)
          const componentName = header.replace(/ (fixed_amount|percentage|percentage_of)$/, '');

          if (!seenComponents.has(componentName)) {
            seenComponents.add(componentName);
            componentNames.push(componentName);
          }
        });

        // Transform data for API
        const transformedData = processedData.map(row => {
          const employeeData = {
            emp_code: row.emp_code,
            name: row.name,
            salary_components: []
          };

          componentNames.forEach(component => {
            const fixedAmount = row[`${component} fixed_amount`];
            const percentage = row[`${component} percentage`];
            const percentageOf = row[`${component} percentage_of`];

            if (fixedAmount !== null || percentage !== null || percentageOf !== null) {
              employeeData.salary_components.push({
                name: component,
                fixed_amount: fixedAmount !== null ? Number(fixedAmount) : null,
                percentage: percentage !== null ? Number(percentage) : null,
                percentage_of: percentageOf
                  ? percentageOf.split(', ').map(item => ({ name: item.trim() }))
                  : []
              });
            }
          });

          return employeeData;
        });

        console.log("transformedData");
        console.log(transformedData);
        setJsonData({
          rawData: processedData, // Original Excel data
          transformedData, // Data formatted for API
          componentNames, // Components in original order
          headers // All headers for reference
        });

        setFileName(file.name);
      } catch (error) {
        console.error("Error processing file:", error);
        toast.error("Error processing Excel file. Please check the format.");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        // Get the first sheet (default to first sheet if 'Salary Format' doesn't exist)
        const sheetName = workbook.SheetNames.includes('Salary Format')
          ? 'Salary Format'
          : workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];

        // Convert to JSON with header row
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

        console.log("jsonData");
        console.log(jsonData);

        if (jsonData.length < 2) {
          toast.error("Excel file is empty or has no data");
          return;
        }

        // Extract headers (first row)
        const headers = jsonData[0];

        // Process data rows (skip header row)
        const transformedData = jsonData.slice(1).map(row => {
          const employeeData = {
            emp_code: row[headers.indexOf('emp_code')],
            name: row[headers.indexOf('name')]
          };

          // Add all other fields exactly as they appear in Excel
          headers.forEach(header => {
            if (header !== 'emp_code' && header !== 'name') {
              const value = row[headers.indexOf(header)];
              employeeData[header] = value !== undefined ? value : null;

              // Convert numbers from strings if needed
              if (typeof employeeData[header] === 'string' && !isNaN(employeeData[header])) {
                employeeData[header] = parseFloat(employeeData[header]);
              }
            }
          });

          return employeeData;
        });

        console.log("transformedData");
        console.log(transformedData);

        const componentNames = [];
        const seenComponents = new Set();

        headers.forEach(header => {
          if (header === 'emp_code' || header === 'name') return;

          // Extract base component name (remove suffix)
          const componentName = header.replace(/ (fixed_amount|percentage|percentage_of)$/, '');

          if (!seenComponents.has(componentName)) {
            seenComponents.add(componentName);
            componentNames.push(componentName);
          }
        });

        setJsonData({
          rawData: jsonData, // Original Excel data including headers
          transformedData, // Data in flat format matching Excel structure
          componentNames, // Components in original order
          headers // All headers for reference
        });

        setFileName(file.name);
      } catch (error) {
        console.error("Error processing file:", error);
        toast.error("Error processing Excel file. Please check the format.");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleFileClear = () => {
    setFileName("")
    setExcelJson(null)
    setJsonData(null);
    setDocInputState({});
    setDocErrors({})
  };

  const [loading, setLoading] = useState(false); //loading logic

  const handleSubmit = async () => {
    if (!jsonData?.transformedData) {
      alert("Please upload an Excel file first!");
      return;
    }

    if (jsonData) {
      const cleanedData = jsonData.transformedData.map(row => {
        const cleanedRow = {};
        Object.keys(row).forEach(key => {
          if (row[key] !== null && row[key] !== undefined && row[key] !== '') {
            cleanedRow[key] = row[key];
          }
        });
        return cleanedRow;
      });

      console.log('Cleaned data---', cleanedData);

      const loadingToastId = toast.loading("Loading: Please wait...");
      setLoading(true);

      try {
        const response = await axios.post(
          `${BASE_URL}/siteproject/bulkcustomdeductionupdate/`,
          cleanedData
        );

        if (response.status === 200 || response.status === 201) {
          toast.success('Salary uploaded successfully!');
          await getPayrunlist();
          handleClose();
        }
      } catch (error) {
        console.error('Error uploading salary:', error);
        toast.error('Error uploading Salary Structures.');
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };


  const [selectedIndex, setSelectedIndex] = useState(-1);

  const handleClick = (index) => {
    setSelectedIndex(index);
  };

  return (
    <>
      <button
        title="Bulk Upload Salary Data"
        className="model-button font-weight500 model-button-print"
        onClick={handleShow}
        style={{ margin: "2px" }}
      >
        <CloudUpload />
      </button>

      <Modal show={show} dialogClassName="ourcompany-model">
        <Modal.Header className="task-Tab-heading font-weight500  justify-between  font-size-heading ">
          <Modal.Title>Bulk Update Salary Data in Format:</Modal.Title>
          <div>
            <div className="flex-row">
              <DownloadSalaryBulkFormat />
            </div>
          </div>

        </Modal.Header>
        <Modal.Body>

          <div
            className="table-css-white-background"
            style={{ display: "none" }}
          >
            <table
              ref={bulktableRef}
              id="my-table"
              style={{
                borderColor: "#323232",
                borderRadius: "5px",
                padding: "0px 5px",
                borderWidth: "1px",
                // marginLeft: "10px",
                // zoom: "70%",
              }}
            >
              <thead                            >
                <tr>
                  <th className="summary-excel-tab br-5">emp_code</th>
                  <th className="summary-excel-tab br-5">name</th>
                  {salaryStructureHeadings.sort((a, b) => a.sorting_var - b.sorting_var).map((heading) => (
                    <React.Fragment key={heading.id}>
                      <th>{heading.title} fixed_amount</th>
                      <th>{heading.title} percentage</th>
                      <th>{heading.title} percentage_of</th>
                    </React.Fragment>
                  ))}
                </tr>
              </thead>
              {
                // buffer ? <div className="spinner"></div> :
                <tbody>
                  {allEmployeeList
                    .sort((a, b) => a.emp_code - b.emp_code)
                    .map((data, index) => {
                      const inactivename = data.employee_status === "inactive" ? "#ff1212" : "black";
                      return (
                        <>
                          <tr
                            style={{
                              backgroundColor:
                                index === selectedIndex ? "yellow" : "white",
                              color: inactivename,
                            }}
                          >
                            <td className="summary-excel-tab br-5">{data.emp_code}</td>
                            <td className="summary-excel-tab br-5">{data.name}</td>
                          </tr>
                        </>
                      );
                    })}
                </tbody>
              }
            </table>
          </div>


          <div className="flex-column field-cont-div">
            <label htmlFor="document_file" className="form-labels font-weight500 font-size-heading">
              Upload File
            </label>
            <div className="flex-row">
              <div>

                <label
                  htmlFor="document_file"
                  className={`align-center custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                    }`}
                  style={{ cursor: 'pointer' }}
                >
                  <div className={`align-center pdf-input  ${docErrors.document_file ? 'error' : ''}`}>
                    <Attachment />
                  </div>
                </label>
                <input
                  type="file"
                  accept=".xlsx, .xls"
                  onChange={handleFileUpload}
                  id="document_file"
                  name="document_file"
                  className="align-center"
                  style={{ display: "none", position: "relative" }} />
              </div>
              {fileName && <p className="file-name align-center">{fileName}</p>}
              {fileName && <div>
                <button className="model-button" onClick={handleFileClear}>Clear</button>
              </div>}
            </div>
            <br />
            {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}

          </div>


          {jsonData && (
            <div>
              <h4>Salary Structure Data Preview</h4>
              <div className="scroll-container-table" style={{ maxHeight: '600px', overflowY: 'auto' }}>
                <table className="scrollfix-table-css">
                  <thead>
                    <tr className="custom-table-head-tr">
                      <th rowSpan="2" className="sticky-header">Emp Code</th>
                      <th rowSpan="2" className="sticky-header">Name</th>

                      {/* Dynamic column groups */}
                      {jsonData.componentNames?.map(component => (
                        <th colSpan="3" className="section-header" key={component}>
                          {component}
                        </th>
                      ))}
                    </tr>
                    <tr className="custom-table-head-tr">
                      {/* Subheaders */}
                      {jsonData.componentNames?.flatMap(component => [
                        <th key={`${component}-fixed`} className="sub-header">Fixed</th>,
                        <th key={`${component}-percent`} className="sub-header">%</th>,
                        <th key={`${component}-of`} className="sub-header">Of</th>
                      ])}
                    </tr>
                  </thead>
                  <tbody>
                    {jsonData.transformedData?.map((row, index) => (
                      <tr key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white' }}>
                        <td>{row.emp_code}</td>
                        <td>{row.name}</td>

                        {/* Dynamic data cells */}
                        {jsonData.componentNames?.flatMap(component => [
                          <td key={`${component}-fixed`} className="align-right">
                            {row[`${component} fixed_amount`] || '-'}
                          </td>,
                          <td key={`${component}-percent`} className="align-center">
                            {row[`${component} percentage`] || '-'}
                          </td>,
                          <td key={`${component}-of`} className="align-left">
                            {row[`${component} percentage_of`] || '-'}
                          </td>
                        ])}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="button-models">
            <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
              Cancel
            </button>
            <button className="model-button-download model-button font-weight500" onClick={handleSubmit} disabled={loading}>
              {/* <UploadIcon /> */}
              <CloudUpload />
              {"  "} {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </Modal.Body >
      </Modal >
      <ToastContainer position="top-center" autoClose={10000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );

};

const UploadSiteProject = ({ id, getProject, ProjectList, getContractorProjects }) => {



  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState("");
  const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
  const [docErrors, setDocErrors] = useState({});
  const [docInputState, setDocInputState] = useState({});

  const bulktableRef = useRef(null);
  const handleDownload = () => {
    const table = bulktableRef.current;
    const wb = XLSX.utils.table_to_book(table, { sheet: "Salary Details" });
    const wbout = XLSX.write(wb, { bookType: "xls", type: "binary" });

    const blob = new Blob([s2ab(wbout)], {
      type: "application/vnd.ms-excel",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Salary Data List.xls";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  const handleClose = () => {
    setFileName("")
    setExcelJson(null)
    setDocErrors({})
    setShow(false)
  };
  const handleShow = () => setShow(true);

  // Function to handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check for valid file type
      const validFileTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
      if (!validFileTypes.includes(file.type)) {
        setDocErrors({ document_file: "Please upload a valid Excel file (.xlsx or .xls)." });
        setFileName("");
        return;
      }

      setFileName(file.name);
      readExcel(file); // Convert the file to JSON
    } else {
      setFileName("");
    }
  };

  const checkForDuplicates = (data) => {
    const sitecodes = new Map();
    const duplicates = [];

    // Track positions of each insurance number
    data.forEach((i, index) => {
      const projectcode = i.site_prcode;
      if (sitecodes.has(projectcode)) {
        // If the insurance number already exists, add the current position to its list
        sitecodes.get(projectcode).push(index + 1); // index + 1 for 1-based position
      } else {
        // If it's the first time seeing this insurance number, initialize its position list
        sitecodes.set(projectcode, [index + 1]);
      }
    });

    // Now, filter out only the numbers that appear more than once
    sitecodes.forEach((positions, projectcode) => {
      if (positions.length > 1) {
        duplicates.push(`\Site Project Code :${projectcode} is found in position(s) ${positions.join(", ")}`);
      }
    });

    return duplicates;
  };


  const readExcel = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0]; // Use the first sheet
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });

      const headers = json[0];
      const rows = json.slice(1);

      const convertToYYYYMMDD = (input) => {
        try {
          let date;

          // Handle Excel serial dates
          if (typeof input === "number") {
            const excelEpoch = new Date(1900, 0, 1); // Excel epoch starts on Jan 1, 1900
            const daysOffset = input - 1; // Subtract 1 because of leap year bug
            date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
          } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
            // Format: YYYY.MM.DD
            const [year, month, day] = input.split('.');
            date = new Date(`${year}-${month}-${day}`);
          } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
            // Format: DD.MM.YYYY
            const [day, month, year] = input.split('.');
            date = new Date(`${year}-${month}-${day}`);
          } else {
            // Default parsing for other formats
            date = new Date(input);
          }

          if (isNaN(date.getTime())) {
            throw new Error('Invalid date format');
          }

          // Format the date as YYYY-MM-DD
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
          const day = String(date.getDate()).padStart(2, '0');

          return `${year}-${month}-${day}`;
        } catch (error) {
          return null; // Return null for invalid dates
        }
      };

      // Create a formatted JSON object based on headers and row values
      const formattedJson = rows.map((row) => {
        const obj = {};
        headers.forEach((header, index) => {

          if (["agreement_date", "commencement_date", "loa_award_date", "actual_completion_date", "schedule_completion_date", "actual_construction_completion_date", "schedule_construction_completion_date", "bid_due_date"].includes(header) && row[index] && typeof row[index] === "number") {
            obj[header] = convertToYYYYMMDD(row[index]); // Convert date
          } else {
            obj[header] = row[index] !== undefined ? row[index] : null;
          }
        });
        return obj;
      });


      // Ensure the input to checkForDuplicates is an array
      const duplicates = checkForDuplicates(formattedJson);

      if (duplicates.length > 0) {
        // Toast notification with line breaks for each duplicate
        toast.error(
          `Duplicate Projects found:\n${duplicates.join("\n")}`,
          {
            autoClose: 5000, // Close toast after 5 seconds
          }
        );
      }


      // Set the formatted JSON data to state
      setExcelJson(formattedJson);
    };
    reader.readAsArrayBuffer(file);

  };

  // Function to handle the upload button click
  const handleUpload = async () => {

    if (excelJson) {
      const duplicates = checkForDuplicates(excelJson);

      if (duplicates.length > 0) {
        toast.error(`Duplicate Data found:\n ${duplicates.join(", ")}`, {
          autoClose: 5000,
        });
      }
      const loadingToastId = toast.loading("Uploading: Please wait...");
      try {
        const res = await axios.post(`${BASE_URL}/siteproject/projectbulkuploadadd/`, excelJson);
        if (res.status === 200) {
          await getProject();
          await getContractorProjects();
          handleClose();
          toast.dismiss(loadingToastId);
          toast.success("Projects uploaded successfully.");

        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to add data!");
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    } else {
      setDocErrors({ document_file: "Please upload a valid Excel file." });
    }
  };





  return (
    <>

      <button title="Upload" className="model-button   font-weight500   model-button-print" onClick={handleShow} style={{ margin: "2px" }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
          <g fill="none" fill-rule="evenodd" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
            <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
          </g>
        </svg>
      </button>

      <Modal show={show} dialogClassName="ourcompany-model">

        <Modal.Body>
          <div className="flex-row align-center">

            <h1 className="font-size-text task-Tab-heading align-center  font-weight500 "><Modal.Title>Upload Bulk Project Data in format :</Modal.Title> </h1>


            <button onClick={handleDownload} className="model-button-download model-button font-weight500">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="download" fill="#fff">
                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                </g>
              </svg>
              {"  "} Format
            </button>

          </div>

          <div className="table-css-white-background" style={{ display: "none" }}>
            <table ref={bulktableRef} className="nested-table-lightblue">
              <thead>
                <tr className="custom-table-head-tr">
                  <th className="align-left">site_prcode</th>
                  <th className="table-heading-text">project_name</th>
                  <th className="table-heading-text">project_short_name</th>
                  <th className="table-heading-text">location</th>
                  <th className="table-heading-text">sub_company</th>
                  <th className="table-heading-text">work_type</th>
                  <th className="table-heading-text">bid_due_date</th>
                  <th className="table-heading-text">commencement_date</th>
                  <th className="table-heading-text">loa_award_date</th>
                  <th className="table-heading-text">actual_construction_completion_date</th>
                  <th className="table-heading-text">schedule_construction_completion_date</th>
                  <th className="table-heading-text">agreement_date</th>
                  <th className="table-heading-text">concern_person_name</th>
                  <th className="table-heading-text">tender_id</th>
                  <th className="table-heading-text">actual_completion_date</th>
                  <th className="table-heading-text">schedule_completion_date</th>
                  <th className="table-heading-text">remark</th>
                  <th className="table-heading-text">project_length</th>
                  <th className="table-heading-text">consultancy_fees</th>
                  <th className="table-heading-text">contract_mode</th>
                  <th className="table-heading-text">jv</th>
                  <th className="table-heading-text">lead</th>
                  <th className="table-heading-text">our_share</th>
                  <th className="table-heading-text">association</th>
                  <th className="table-heading-text">client_name</th>
                  <th className="table-heading-text">project_key_point</th>
                  <th className="table-heading-text">ro</th>
                  <th className="align-right">ro_address</th>
                  <th className="align-right">piu_address</th>
                  <th className="align-right">project_duration</th>
                  <th className="align-right">our_role</th>
                  <th className="align-right">site_office_address</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className="align-left">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-center">-</th>
                  <th className="align-right">-</th>
                  <th className="align-right">-</th>
                  <th className="align-right">-</th>
                  <th className="align-right">-</th>
                  <th className="align-right">-</th>
                  <th className="align-right">-</th>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="table-css-white-background scroll-container"
          >
            <div className="table-container scrollbar" style={{ width: "100%" }}>
              <table className="nested-table-lightblue" style={{ margin: "0px" }}>
                <thead className="table-heading">
                  <tr className="custom-table-head-tr modal-padding-heading">
                    <th className="table-heading-text">Project Code</th>
                    <th className="table-heading-text">Project Name</th>
                    <th className="table-heading-text">Project Short Name</th>
                    <th className="table-heading-text">Location</th>
                    <th className="table-heading-text">Sub Company</th>
                    <th className="table-heading-text">Work Type</th>
                    <th className="table-heading-text">Bid Due Date</th>
                    <th className="table-heading-text">Commencement Date</th>
                    <th className="table-heading-text">LOA Award Date</th>
                    <th className="table-heading-text">Actual Construction Completion Date</th>
                    <th className="table-heading-text">Schedule Construction Completion Date</th>
                    <th className="table-heading-text">Agreement Date</th>
                    <th className="table-heading-text">Concern Person Name</th>
                    <th className="table-heading-text">Tender ID</th>
                    <th className="table-heading-text">Actual Completion Date</th>
                    <th className="table-heading-text">Schedule Completion Date</th>
                    <th className="table-heading-text">Remark</th>
                    <th className="table-heading-text">Project Length</th>
                    <th className="table-heading-text">Consultancy Fees</th>
                    <th className="table-heading-text">Contract Mode</th>
                    <th className="table-heading-text">JV</th>
                    <th className="table-heading-text">Lead</th>
                    <th className="table-heading-text">Our Share</th>
                    <th className="table-heading-text">Association</th>
                    <th className="table-heading-text">Client Name</th>
                    <th className="table-heading-text">Project Key Point</th>
                    <th className="table-heading-text">RO</th>
                    <th className="table-heading-text">RO Address</th>
                    <th className="table-heading-text">PIU Address</th>
                    <th className="table-heading-text">Project Duration</th>
                    <th className="table-heading-text">Our Role</th>
                    <th className="table-heading-text">Site Office Address</th>
                  </tr>
                </thead>
                <tbody>
                  {excelJson?.map((project, index) => (
                    <tr key={index} className="modal-padding-heading">
                      <th className="table-heading-text">{project.site_prcode}</th>
                      <th className="table-heading-text">{project.project_name}</th>
                      <th className="table-heading-text">{project.project_short_name}</th>
                      <th className="table-heading-text">{project.location}</th>
                      <th className="table-heading-text">{project.sub_company}</th>
                      <th className="table-heading-text">{project.work_type}</th>
                      <th className="table-heading-text">{project.bid_due_date}</th>
                      <th className="table-heading-text">{project.commencement_date}</th>
                      <th className="table-heading-text">{project.loa_award_date}</th>
                      <th className="table-heading-text">{project.actual_construction_completion_date}</th>
                      <th className="table-heading-text">{project.schedule_construction_completion_date}</th>
                      <th className="table-heading-text">{project.agreement_date}</th>
                      <th className="table-heading-text">{project.concern_person_name}</th>
                      <th className="table-heading-text">{project.tender_id}</th>
                      <th className="table-heading-text">{project.actual_completion_date}</th>
                      <th className="table-heading-text">{project.schedule_completion_date}</th>
                      <th className="table-heading-text">{project.remark}</th>
                      <th className="table-heading-text">{project.project_length}</th>
                      <th className="table-heading-text">{project.consultancy_fees}</th>
                      <th className="table-heading-text">{project.contract_mode}</th>
                      <th className="table-heading-text">{project.jv}</th>
                      <th className="table-heading-text">{project.lead}</th>
                      <th className="table-heading-text">{project.our_share}</th>
                      <th className="table-heading-text">{project.association}</th>
                      <th className="table-heading-text">{project.client_name}</th>
                      <th className="table-heading-text">{project.project_key_point}</th>
                      <th className="table-heading-text">{project.ro}</th>
                      <th className="table-heading-text">{project.ro_address}</th>
                      <th className="table-heading-text">{project.piu_address}</th>
                      <th className="table-heading-text">{project.project_duration}</th>
                      <th className="table-heading-text">{project.our_role}</th>
                      <th className="table-heading-text">{project.site_office_address}</th>
                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>

          <div className="flex-column field-cont-div">
            <label htmlFor="document_file" className="form-labels announce-date font-weight500 font-size-heading">
              Upload File
            </label>
            <label
              htmlFor="document_file"
              className={`align-center form-inputss custom-file-upload ${docErrors.document_file ? "error" : docInputState.document_file ? "success" : ""
                }`}
            >
              <svg
                className="pdf-input"
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                  stroke="#707070"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </label>
            <input
              id="document_file"
              name="document_file"
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="file-inputs align-center"
              style={{ display: "none", position: "relative" }}
            />
            {fileName && <p className="file-name align-center">{fileName}</p>}
            <br />
            {docErrors.document_file && <span className="file-name error-message font-size-text ">{docErrors.document_file}</span>}
          </div>

          <h4>References:</h4>
          <div className="reference-container">
            <div className="reference-section">
              <p className="reference-title">General:</p>
              <ul className="arrow-list">
                <li>Site prcode should be unique</li>

              </ul>
            </div>
            <div className="reference-section">
              <p className="reference-title">For Work Type use one of these:</p>
              <ul className="arrow-list">
                <li>construction consultant</li>
                <li>operations & maintenance consultant</li>
                <li>safety consultant</li>
                <li>dpr</li>
              </ul>
            </div>
            <div className="reference-section">
              <p className="reference-title">For Our Role use one of these:</p>
              <ul className="arrow-list">
                <li>active</li>
                <li>partially</li>
                <li>silent</li>
              </ul>
            </div>
            <div className="reference-section">
              <p className="reference-title">For Contract Mode use one of these:</p>
              <ul className="arrow-list">
                <li>epc</li>
                <li>ham</li>
                <li>bot</li>
              </ul>
            </div>
            <div className="date-section">
              <p className="date-text">All Dates should be in DD-MM-YYYY format</p>
            </div>
          </div>


          <div className="button-models">
            <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
              Cancel
            </button>
            <button className="model-button-download model-button font-weight500" onClick={handleUpload}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="22" id="upload">
                <g fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                </g>
              </svg>
              {"  "} Upload
            </button>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const RunPayRoll = ({ month, year }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [loading, setLoading] = useState(false); //loading logic
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); //loading logic
    try {
      let res = await axios.post(
        `${BASE_URL}/siteproject/salaryslipallpost/${year}/${month}/`
      );

      if (res.status === 200) {
        handleClose();
      } else {
        alert(res);
      }
    } catch (err) {
      alert(err);
    } finally {
      setLoading(false); //loading logic
    }
  };
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const monthName = monthNames[month - 1];

  return (
    <>
      <button
        className="model-view-button model-add"
        title="Run Pay Roll"
        onClick={handleShow}
      >
        <svg
          width="24"
          height="24"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 512 512"
          id="payroll"
        >
          <g>
            <path d="M72.36,492.088a13.5,13.5,0,0,0,14.3-1.8l32.079-26.753,38.644,31.19.093.072a13.438,13.438,0,0,0,16.669-.039l.095-.076,38.2-31.17,38.2,31.17.094.076a13.438,13.438,0,0,0,16.668.039l.092-.072,38.64-31.191,32.072,26.753h0a13.608,13.608,0,0,0,14.371,1.8A12.526,12.526,0,0,0,360,480.775V428.44l21.848,18.291a13.246,13.246,0,0,0,8.516,3.074,12.576,12.576,0,0,0,5.517-1.275A12.248,12.248,0,0,0,403,437.217V384.883l22.127,18.291a13.623,13.623,0,0,0,8.656,3.074,13.839,13.839,0,0,0,5.807-1.275A12.519,12.519,0,0,0,447,393.66V49.843C447,30.264,429.723,14,408.542,14H190.573C169.392,14,152,30.264,152,49.843V58h-4.984C125.834,58,109,73.821,109,93.4V101h-5.542C82.277,101,65,117.378,65,136.958V480.775A12.473,12.473,0,0,0,72.36,492.088ZM168,49.843C168,39.086,178.214,30,190.573,30H408.542C420.9,30,431,39.086,431,49.843V387.034l-28-22.986V93.4C403,73.821,386.166,58,364.984,58H168ZM125,93.4c0-10.757,9.657-19.4,22.016-19.4H364.984C377.343,74,387,82.643,387,93.4V430.592L360,407.6V136.958C360,117.378,342.608,101,321.427,101H125ZM81,136.958C81,126.2,91.1,117,103.458,117H321.427C333.786,117,344,126.2,344,136.958V474.149l-29.193-24.285c-.033-.027-.105-.054-.138-.081a13.441,13.441,0,0,0-16.791-.125c-.031.025-.072.049-.1.073l-38.665,31.207L220.9,449.76l-.1-.077a13.428,13.428,0,0,0-16.716,0l-.095.077-38.21,31.178-38.66-31.207-.092-.073a13.411,13.411,0,0,0-16.771.125c-.033.027-.088.054-.121.081L81,474.149Z"></path>
            <path d="M149.586 404H275.3a8 8 0 0 0 0-16H149.586a8 8 0 0 0 0 16zM212.443 314.73a28 28 0 0 1-27.967-27.966 8 8 0 0 0-16 0A44.038 44.038 0 0 0 202 329.467V344a8 8 0 0 0 16 0V330.367a43.961 43.961 0 0 0-5.557-87.57 27.964 27.964 0 0 1-2.621-55.806c.06 0 .118.009.178.009a7.989 7.989 0 0 0 1.236-.1c.4-.017.8-.031 1.207-.031a28 28 0 0 1 27.966 27.967 8 8 0 1 0 16 0A44.023 44.023 0 0 0 218 171.228V159a8 8 0 0 0-16 0v13.128A43.963 43.963 0 0 0 212.443 258.8a27.967 27.967 0 0 1 0 55.933z"></path>
          </g>
        </svg>
      </button>

      <Modal show={show} dialogClassName="request-leave width-40vw">
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <h3 className="task-Tab-heading  font-weight500    font-size-heading">
                Run Pay Rolls for "{monthName}-{year}"
              </h3>
              <p style={{ textAlign: "center" }}>
                Confirm Running Pay Roll for the year: {year}, month:{" "}
                {monthName}
              </p>

              <div className="button-models">
                <button
                  className="model-button  font-weight500   "
                  onClick={handleClose}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button  font-weight500    model-button-leave font-weight500    font-size-heading"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  Run
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};




// ! ***************  SalaryStructureHeading Crud Models Start ***************

const SalaryStructureHeadingAdd = ({ salaryStructureHeadings, getSalaryStructureHeadings }) => {
  const [show, setShow] = useState(false);
  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
  const [salaryslipView, setSalarySlipView] = useState(true);
  const [finalAmount, setFinalAmount] = useState(false);

  const handleClose = () => {
    setFormData({
      title: "",
      sub_company: sessionStorage.getItem('sitemanagement_project_sub_company' || null),
      sorting_var: "",
      salary_type: "",
    });
    setSalarySlipView(false);
    setFinalAmount(false);
    setShow(false);
  };

  const handleShow = () => {
    setSalarySlipView(true);
    setShow(true)
  };

  const [formData, setFormData] = useState({
    title: "",
    sub_company: sessionStorage.getItem('sitemanagement_project_sub_company' || null),
    sorting_var: "",
    salary_type: "",
  });
  const [suggestion, setSuggestPosition] = useState("")

  useEffect(() => {
    const getNextSortingPosition = () => {
      const maxSortingVar = Math.max(
        ...salaryStructureHeadings.map((heading) => Number(heading.sorting_var)),
        1
      );
      setSuggestPosition(maxSortingVar + 1);
    };

    getNextSortingPosition();
  }, [salaryStructureHeadings]);

  // Validation
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "title",
      "sub_company",
      "sorting_var",
      "salary_type",
    ];


    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    // // Add more validation for numerical fields as needed
    // if (formData.epf_criteria && isNaN(formData.epf_criteria)) {
    //   newErrors.epf_criteria = 'EPF criteria must be a valid number!';
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const updatedFormData = {
      ...formData,
      salaryslip: salaryslipView,
      final_salary: finalAmount,
    };
    if (validateForm()) {
      const loadingToastId = toast.loading('Loading: Please wait...');
      setLoading(true); //loading logic
      try {
        let res = await axios.post(`${BASE_URL}/siteproject/salaryheading/`, updatedFormData);
        if (res.status === 200) {
          await getSalaryStructureHeadings();
          handleClose();
          // toast.success('Salary Policy created successfully!');
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false); //loading logic
      }
    }
  };

  return (
    <>
      <button className="models-button model-add" title="Add Salary Heading" onClick={handleShow}>
        <AddwithBlueCircle />
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton className=" task-Tab-heading font-weight500    font-size-heading ">
          <Modal.Title>Add Salary Heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">

              <div className="flex-column">
                <label htmlFor="title" className="form-labels  font-weight500    font-size-subheading">
                  Title<span className="required">*</span>
                </label>
                <input
                  maxLength={50}
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Heading Name"
                  onChange={handleInputChange}
                  value={formData.title}
                  className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
                    }`}
                />
                {errors.title && (
                  <span className="error-message font-size-text ">{errors.title}</span>
                )}
              </div>


              <div className="flex-column form-group-selectt">
                <label htmlFor="salary_type " className="form-labels  font-weight500    font-size-subheading">
                  Salary Type<span className="required">*</span>
                </label>
                <br />
                <select
                  id="salary_type"
                  name="salary_type"
                  value={formData.salary_type}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.salary_type ? "error" : inputState.salary_type ? "success" : ""
                    }`}
                >
                  <option value="">Select Salary Type</option>
                  <option value="allowance">Allowance</option>
                  <option value="deduction">Deduction</option>
                  <option value="total">Total</option>
                  <option value="difference">Difference</option>
                </select>
                <div className="form-group-selection-arrow">

                </div>
                {errors.salary_type && (
                  <span className="error-message font-size-text ">{errors.salary_type}</span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="sorting_var" className="form-labels  font-weight500    font-size-subheading">
                  Heading Sort Position (1 is Top)<span className="required">*</span>
                </label>
                <input
                  id="sorting_var"
                  name="sorting_var"
                  type="number"
                  min={1}
                  maxLength={10}
                  placeholder={`Heading Position (Suggestion: ${suggestion})`}
                  onWheel={(e) => e.target.blur()}
                  onChange={handleInputChange}
                  value={formData.sorting_var}
                  className={`form-input ${errors.sorting_var ? "error" : inputState.sorting_var ? "success" : ""
                    }`}
                />
                {errors.sorting_var && (
                  <span className="error-message font-size-text ">{errors.sorting_var}</span>
                )}
              </div>

              {PERMISSION_AUTHORITY ?
                <div className="flex-column form-group-selectt">
                  <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                    Sub Company<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="sub_company"
                    name="sub_company"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                      }`}
                  >
                    <option value="">Select Site Company</option>
                    {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                  </select>
                  <div className="form-group-selection-arrow">

                  </div>
                  {errors.sub_company && (
                    <span className="error-message font-size-text ">{errors.sub_company}</span>
                  )}
                </div>
                : null
              }
              {/* <div className="flex-row justify-between"> */}
              <div className="flex-row ">
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    id="toggle1"
                    checked={salaryslipView}
                    onChange={() => setSalarySlipView(!salaryslipView)}
                  />
                  <label htmlFor="toggle1"></label>
                </div>
                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                <label htmlFor="EmpCode" className="form-labels  font-weight500    font-size-subheading">
                  {salaryslipView ? "View" : "Hide"} in Salary Slip {" "}
                </label>
              </div>
              <div className="flex-row ">
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    id="toggle2"
                    checked={finalAmount}
                    onChange={() => setFinalAmount(!finalAmount)}
                  />
                  <label htmlFor="toggle2"></label>
                </div>
                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                <label htmlFor="EmpCode" className="form-labels  font-weight500    font-size-subheading">
                  Final Salary Amount {" "}
                </label>
              </div>
              {/* </div> */}
              <div className="button-models">
                <button className="model-button model-button-cancel  font-weight500   " onClick={handleClose}>
                  Cancel
                </button>
                <button
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const SalaryStructureHeadingUpdate = ({ i, salaryStructureHeadings, getSalaryStructureHeadings, SUB_COMPANIES, PERMISSION_AUTHORITY }) => {
  const [show, setShow] = useState(false);
  const [salaryslipView, setSalarySlipView] = useState(i.salaryslip || false);
  const [finalAmount, setFinalAmount] = useState(i.final_salary || false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setFormData(i);
    setShow(true);
  };

  const [formData, setFormData] = useState({
    title: "",
    sub_company: sessionStorage.getItem('sitemanagement_project_sub_company' || null),
    sorting_var: "",
    salary_type: "",
  });


  console.log("Formdata");
  console.log(formData);

  const [suggestion, setSuggestPosition] = useState("")

  useEffect(() => {
    const getNextSortingPosition = () => {
      const maxSortingVar = Math.max(
        ...salaryStructureHeadings.map((heading) => Number(heading.sorting_var)),
        1
      );
      setSuggestPosition(maxSortingVar + 1);
    };

    getNextSortingPosition();
  }, [salaryStructureHeadings]);

  // Validation
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "title",
      "sub_company",
      "sorting_var",
      "salary_type",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const updatedFormData = {
      ...formData,
      salaryslip: salaryslipView,
      final_salary: finalAmount,
    };
    if (validateForm()) {
      const loadingToastId = toast.loading('Loading: Please wait...');
      setLoading(true); //loading logic
      try {
        let res = await axios.put(`${BASE_URL}/siteproject/salaryheading/${i.id}/`, updatedFormData);
        if (res.status === 200) {
          await getSalaryStructureHeadings();
          setShow(false);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false); //loading logic
      }
    }
  };

  return (
    <>
      <button className="model-edit-button" title="Update Salary Heading" onClick={handleShow}>
        <UpdatePencil />
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton className=" task-Tab-heading font-weight500    font-size-heading ">
          <Modal.Title>Update Salary Heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <div className="flex-column">
                <label htmlFor="title" className="form-labels  font-weight500    font-size-subheading">
                  Title<span className="required">*</span>
                </label>
                <input
                  maxLength={50}
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Salary Heading Title"
                  onChange={handleInputChange}
                  value={formData.title}
                  className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
                    }`}
                />
                {errors.title && (
                  <span className="error-message font-size-text ">{errors.title}</span>
                )}
              </div>

              <div className="flex-column form-group-selectt">
                <label htmlFor="salary_type " className="form-labels  font-weight500    font-size-subheading">
                  Salary Type<span className="required">*</span>
                </label>
                <br />
                <select
                  id="salary_type"
                  name="salary_type"
                  value={formData.salary_type}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.salary_type ? "error" : inputState.salary_type ? "success" : ""
                    }`}
                >
                  <option value="">Select Salary Type</option>
                  <option value="allowance">Allowance</option>
                  <option value="deduction">Deduction</option>
                  <option value="total">Total</option>
                  <option value="difference">Difference</option>
                </select>
                <div className="form-group-selection-arrow">

                </div>
                {errors.salary_type && (
                  <span className="error-message font-size-text ">{errors.salary_type}</span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="sorting_var" className="form-labels  font-weight500    font-size-subheading">
                  Heading Sort Position (1 is Top)<span className="required">*</span>
                </label>
                <input
                  id="sorting_var"
                  name="sorting_var"
                  type="number"
                  min={1}
                  maxLength={10}
                  placeholder={`Heading Position (Suggestion: ${suggestion})`}
                  onWheel={(e) => e.target.blur()}
                  onChange={handleInputChange}
                  value={formData.sorting_var}
                  className={`form-input ${errors.sorting_var ? "error" : inputState.sorting_var ? "success" : ""
                    }`}
                />
                {errors.sorting_var && (
                  <span className="error-message font-size-text ">{errors.sorting_var}</span>
                )}
              </div>

              {PERMISSION_AUTHORITY ?
                <div className="flex-column form-group-selectt">
                  <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                    Sub Company<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="sub_company"
                    name="sub_company"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                      }`}
                  >
                    <option value="">Select Site Company  </option>
                    {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                  </select>
                  <div className="form-group-selection-arrow">

                  </div>
                  {errors.sub_company && (
                    <span className="error-message font-size-text ">{errors.sub_company}</span>
                  )}
                </div>
                : null
              }
              <div className="flex-row ">
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    id="toggle1"
                    checked={salaryslipView}
                    onChange={() => setSalarySlipView(!salaryslipView)}
                  />
                  <label htmlFor="toggle1"></label>
                </div>
                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                <label htmlFor="EmpCode" className="form-labels  font-weight500    font-size-subheading">
                  {salaryslipView ? "View" : "Hide"} in Salary Slip {" "}
                </label>
              </div>
              <div className="flex-row ">
                <div className="checkbox-toggle">
                  <input
                    type="checkbox"
                    id="toggle2"
                    checked={finalAmount}
                    onChange={() => setFinalAmount(!finalAmount)}
                  />
                  <label htmlFor="toggle2"></label>
                </div>
                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                <label htmlFor="EmpCode" className="form-labels  font-weight500    font-size-subheading">
                  Final Salary Amount {" "}
                </label>
              </div>
              <div className="button-models">
                <button className="model-button model-button-cancel  font-weight500   " onClick={handleClose}>
                  Cancel
                </button>
                <button
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const SalaryStructureHeadingDelete = ({ i, getSalaryStructureHeadings }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/siteproject/salaryheading/${i.id}/`);

      if (res.status === 200) {
        await getSalaryStructureHeadings();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId)
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="model-delete-button" title="Delete Salary Heading" onClick={handleShow}>
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Delete Salary Heading: {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to Delete Salary Salary Heading: "{i.title}"
            <div className="button-models">
              <button className="model-button model-button-cancel  font-weight500    " onClick={handleClose}>
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};


// ? *************** SalaryStructureHeading Crud Models End ***************



const EmployeeSalaryStructure = ({
  code,
  sub_company,
  getSalaryData,
  getSalaryStructure,
}) => {

  const [show, setShow] = useState(false);
  const [customData, setCustomData] = useState([]);
  const handleClose = () => setShow(false);
  const handleShow = async () => {
    getAllSalaryRelatedData(code)
    setShow(true);
  };


  const [salaryData, setSalaryData] = useState({});
  const [deductionData, setDeductionData] = useState([]);
  // const [salaryDeductionPolicies, setSalaryDeductionPolicy] = useState([]);
  const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);

  console.log("sub_company")
  console.log(sub_company)


  const getAllSalaryRelatedData = async (emp_code) => {
    try {
      const salary = await axios.get(
        `${BASE_URL}/siteproject/salarystructurebyemp/${emp_code}/`
      );
      setSalaryData(salary.data);
      // const salary = "null"

      const deduction = await axios.get(`${BASE_URL}/siteproject/customdeductionbysalary_structure/${salary.data.id}/`);
      // const deduction = await axios.get(`${BASE_URL}/siteproject/customdeductionbysalary_structure/${salary}/`);
      setDeductionData(deduction.data);

      const headings = await axios.get(`${BASE_URL}/siteproject/salaryHeadingbysubcompany/${sub_company}/`);
      setSalaryStructureHeadings(headings.data);
      if (Array.isArray(headings.data)) {
        setSalaryStructureHeadings(headings.data);
        const customData = headings.data.map(item => ({
          name: item.id,
          salary_structure: salary.data.id,
          salary_type: item.salary_type,
          sorting_var: item.sorting_var,
          percentage: '',
          percentage_of: [],
          fixed_amount: '',
        }));
        setCustomData(customData);
      } else {
        console.error("Error: Expected a list of Salary Headings");
      }
    } catch (err) {
      // handleErrorToast(err)
    } finally {
    }
  };

  return (
    <>
      <button
        className="model-view-button model-add"
        title="Add Salary Details"
        onClick={handleShow}
      >
        <svg
          width="24"
          height="25"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          id="saving">
          <path d="M28,15V12a3,3,0,0,0-3-3H24c0-.07,0-.13,0-.2A5.8,5.8,0,0,0,18.2,3,5.71,5.71,0,0,0,15,4a5.69,5.69,0,0,0-3.2-1A5.8,5.8,0,0,0,6,8.8c0,.07,0,.13,0,.2H5a3,3,0,0,0-3,3V26a3,3,0,0,0,3,3H25a3,3,0,0,0,3-3V23a2,2,0,0,0,2-2V17A2,2,0,0,0,28,15ZM22,8.8c0,.07,0,.13,0,.2h-4.4c0-.07,0-.13,0-.2a5.8,5.8,0,0,0-1.09-3.38A3.76,3.76,0,0,1,22,8.8ZM8,8.8a3.8,3.8,0,0,1,7.6,0c0,.07,0,.13,0,.2H8C8,8.93,8,8.87,8,8.8ZM26,26a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H25a1,1,0,0,1,1,1v3H21a3,3,0,0,0-3,3v2a3,3,0,0,0,3,3h5Zm-5-5a1,1,0,0,1-1-1V18a1,1,0,0,1,1-1h7v4Z"></path>
        </svg>
      </button >
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="four-fifth-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Salary Structure of : "{code}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div ">
            <div className="bdy-div">
              {/* <UserCustomDeductions
                code={code}
                deductionData={deductionData}
                customData={customData}
                salaryData={salaryData}
                salaryStructureHeadings={salaryStructureHeadings}
                // salaryDeductionPolicies={salaryDeductionPolicies}
                getSalaryData={getSalaryData}
                // getSalaryStructure={getSalaryStructure}
                getAllSalaryRelatedData={getAllSalaryRelatedData}
              /> */}
            </div>
          </div>
        </Modal.Body>
      </Modal >
    </>
  );
};



const PayrollSalaryStructureFormat = ({
  code,
  sub_company,
  getSalaryStructure,
}) => {

  const [show, setShow] = useState(false);
  const [customData, setCustomData] = useState([]);
  const handleClose = () => setShow(false);
  const handleShow = async () => {
    getAllSalaryRelatedData(code)
    setShow(true);
  };
  const [sortingVarBY, setSortingVarBY] = useState(false);
  const [roundOffAmount, setRoundOffAmount] = useState(true);

  console.log("sub_company")
  console.log(sub_company)
  const [salaryData, setSalaryData] = useState({});
  const [deductionData, setDeductionData] = useState([]);
  const [salaryDeductionPolicies, setSalaryDeductionPolicy] = useState([]);
  const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);



  const getAllSalaryRelatedData = async (emp_code) => {
    try {
      const salary = await axios.get(
        `${BASE_URL}/siteproject/salarystructurebyemp/${emp_code}/`
      );
      setSalaryData(salary.data);
      const deduction = await axios.get(`${BASE_URL}/siteproject/customdeductionbysalary_structure/${salary.data.id}/`);
      setDeductionData(deduction.data);

      const policies = await axios.get(`${BASE_URL}/siteproject/salarypolicybysubcompany/${sub_company}/`);
      setSalaryDeductionPolicy(policies.data);

      const headings = await axios.get(`${BASE_URL}/siteproject/salaryHeadingbysubcompany/${sub_company}/`);
      setSalaryStructureHeadings(headings.data);
      if (Array.isArray(headings.data)) {
        setSalaryStructureHeadings(headings.data);
        const customData = headings.data.map(item => ({
          name: item.id,
          salary_structure: salary.data.id,
          salary_type: item.salary_type,
          sorting_var: item.sorting_var,
          percentage: '',
          percentage_of: [],
          fixed_amount: '',
        }));
        setCustomData(customData);
      } else {
        console.error("Error: Expected a list of Salary Headings");
      }
    } catch (err) {
      handleErrorToast(err)
    } finally {
    }
  };


  return (
    <>
      <button
        className="model-view-button model-add"
        title="Add Salary Details"
        onClick={handleShow}
      >
        <svg
          width="24"
          height="25"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          id="saving">
          <path d="M28,15V12a3,3,0,0,0-3-3H24c0-.07,0-.13,0-.2A5.8,5.8,0,0,0,18.2,3,5.71,5.71,0,0,0,15,4a5.69,5.69,0,0,0-3.2-1A5.8,5.8,0,0,0,6,8.8c0,.07,0,.13,0,.2H5a3,3,0,0,0-3,3V26a3,3,0,0,0,3,3H25a3,3,0,0,0,3-3V23a2,2,0,0,0,2-2V17A2,2,0,0,0,28,15ZM22,8.8c0,.07,0,.13,0,.2h-4.4c0-.07,0-.13,0-.2a5.8,5.8,0,0,0-1.09-3.38A3.76,3.76,0,0,1,22,8.8ZM8,8.8a3.8,3.8,0,0,1,7.6,0c0,.07,0,.13,0,.2H8C8,8.93,8,8.87,8,8.8ZM26,26a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V12a1,1,0,0,1,1-1H25a1,1,0,0,1,1,1v3H21a3,3,0,0,0-3,3v2a3,3,0,0,0,3,3h5Zm-5-5a1,1,0,0,1-1-1V18a1,1,0,0,1,1-1h7v4Z"></path>
        </svg>
      </button >
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="five-sixth-modal"
      >
        <Modal.Header closeButton>
          <div className="parent-div ">
            <div className="bdy-div">
              <div className="flex-row justify-between">
                <Modal.Title>Salary Structure of : "{code}"</Modal.Title>
                {deductionData.length > 0 &&
                  <>
                    <ClearCustomDeductions
                      salary_structure={salaryData.id}
                      emp_code={code}
                      deductionData={deductionData}
                      getData={getAllSalaryRelatedData}
                      roundOffAmount={roundOffAmount}
                      sortingVarBY={sortingVarBY}
                    />
                  </>}
              </div>

              {deductionData.length > 0 &&
                <div>
                  <div className="d-flex align-items-center ">
                    <div className="checkbox-toggle">
                      <input
                        type="checkbox"
                        id="toggle-sorting"
                        name="show_emp_data"
                        checked={sortingVarBY}
                        onChange={() => setSortingVarBY(!sortingVarBY)}
                      />
                      <label htmlFor="toggle-sorting"></label>
                    </div>
                    <hr className="field-cont-hr" />
                    <div className="d-flex align-items-center">
                      <label className="sort-label me-2">Sort By:</label>
                      <span className="sort-method">
                        {sortingVarBY ? "Slip" : "Structure"}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex align-items-center ">
                    <div className="checkbox-toggle">
                      <input
                        type="checkbox"
                        id="toggle-eoundoff"
                        name="show_emp_data"
                        checked={roundOffAmount}
                        onChange={() => setRoundOffAmount(!roundOffAmount)}
                      />
                      <label htmlFor="toggle-eoundoff"></label>
                    </div>
                    <hr className="field-cont-hr" />
                    <div className="d-flex align-items-center">
                      <label className="sort-label me-2">Show:</label>
                      <span
                        className="sort-method"
                        title={roundOffAmount ? "Rounded Off (0.5+) to next" : "Actual Calculated Amount"}
                      >
                        {roundOffAmount ? "Rounded Off Amount" : "Actual Amount"}
                      </span>
                    </div>
                  </div>

                </div>}

            </div>
          </div>
        </Modal.Header>
        <Modal.Body style={{ padding: "0" }}>
          <div className="">
            <div className="">
              <UserCustomDeductionswithBulk
                code={code}
                deductionData={deductionData}
                customData={customData}
                salaryData={salaryData}
                salaryStructureHeadings={salaryStructureHeadings}
                salaryDeductionPolicies={salaryDeductionPolicies}
                getSalaryStructure={getSalaryStructure}
                getAllSalaryRelatedData={getAllSalaryRelatedData}
                sortingVarBY={sortingVarBY}
                roundOffAmount={roundOffAmount}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal >
    </>
  );
};


function getCalculatedAmount(entry, data, visited = new Set()) {
  if (visited.has(entry.id)) {
    return { value: 0, explanation: `[Cycle detected for ${entry.name_title}]` };
  }

  visited.add(entry.id);

  if (entry.fixed_amount) {
    const amount = parseFloat(entry.fixed_amount);
    return {
      value: amount,
      explanation: `${entry.name_title}: fixed amount = ${amount}`
    };
  }

  if (entry.percentage && entry.percentage_of?.length > 0) {
    const percentage = parseFloat(entry.percentage);
    const components = [];

    const values = entry.percentage_of.map(refItem => {
      const targetEntry = data.find(
        i =>
          i.id === refItem.id ||
          i.name === refItem.id ||
          i.name === refItem.name ||
          i.id === refItem.name
      );

      if (!targetEntry) {
        components.push(`Unknown ref: ${refItem.name || refItem.id}`);
        return 0;
      }

      const { value, explanation } = getCalculatedAmount(targetEntry, data, new Set(visited));
      components.push(`${targetEntry.name_title}: ${value}`);
      return value;
    });

    let baseTotal = 0;
    let breakdown = '';

    if (entry.name_type === 'difference') {
      const sorted = [...values].sort((a, b) => b - a); // Descending order
      const max = sorted[0];
      const restSum = sorted.slice(1).reduce((sum, v) => sum + v, 0);
      baseTotal = Math.max(0, max - restSum); // Ensure non-negative
      breakdown = `Max (${max}) - Sum of rest (${restSum}) = ${baseTotal}`;
    } else {
      baseTotal = values.reduce((sum, v) => sum + v, 0);
      breakdown = `Sum = ₹${baseTotal}`;
    }

    const result = (percentage / 100) * baseTotal;
    const explanation = `${entry.name_title} = (${percentage}%) of [${components.join(', ')}] \n→ ${breakdown} \n→ Final = ${result.toFixed(2)}`;

    return {
      value: result,
      explanation
    };
  }

  return {
    value: 0,
    explanation: `${entry.name_title}: No fixed or percentage defined`
  };
}

const UserCustomDeductionswithBulk = ({
  code,
  salaryData,
  customData,
  deductionData,
  handleClose,
  salaryStructureHeadings,
  getSalaryStructure,
  getAllSalaryRelatedData,
  salaryDeductionPolicies,
  sortingVarBY,
  roundOffAmount,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(customData);
  const [selectedPolicy, setSelectedPolicy] = useState("null");

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handlePolicySelect = (e) => {
    const { value } = e.target;
    setSelectedPolicy(value);

    if (value === "null") {
      // Reset to original data when 'null' is selected
      setFormData(customData);
      return;
    }

    const selected = salaryDeductionPolicies.find(
      (format) => String(format.id) === String(value)
    );

    if (selected) {
      const transformedDeductions = selected.custom_deductions?.map((deduction) => ({
        ...deduction,
        percentage_of: deduction.percentage_of.map((item) => ({
          id: item.name, // switch from item.id to item.name
          name: item.name_title || item.name, // fallback to name if title is missing
          title: item.name_title, // fallback to name if title is missing
        })),
      }));

      setFormData(transformedDeductions);
    }
  };



  const validateForm = () => {
    const newErrors = {};

    if (!selectedPolicy && deductionData.length === 0) {
      newErrors.policy = "Please select a salary policy";
    }

    // Validate each deduction entry
    formData.forEach((entry, index) => {
      if (entry.fixed_amount && (entry.percentage || entry.percentage_of.length > 0)) {
        newErrors[`deduction_${index}`] = "Cannot have both fixed amount and percentage";
      } else if (entry.percentage && entry.percentage_of.length === 0) {
        newErrors[`deduction_${index}`] = "Related To is required when using percentage";
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    console.log("newErrors:", newErrors)
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmitCustomDeduction = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      const validPolicyFormat = formData
        .filter(entry =>
          (entry.fixed_amount) ||
          (entry.percentage && entry.percentage_of.length > 0)
        )
        .map(entry => ({
          ...entry,
          emp_code: code,
          percentage_of: entry.percentage_of?.map(item => item.name) || []
        }));


      const res = await axios.post(
        `${BASE_URL}/siteproject/bulkcustomdeduction/`,
        validPolicyFormat
      );
      if (res.status === 200 || res.status === 201) {
        await getAllSalaryRelatedData(code);
        toast.success("Deductions saved successfully!");
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedFormData = formData.map((entry, i) =>
      i === index ? { ...entry, [name]: value } : entry
    );
    setFormData(updatedFormData);
  };

  const handleSelectChange = (selectedOptions, index) => {
    setFormData(prev => {
      const updatedFormData = [...prev];
      updatedFormData[index] = {
        ...updatedFormData[index],
        percentage_of: selectedOptions
          ? selectedOptions.map(option => ({ id: option.value, name: option.label }))
          : []
      };
      return updatedFormData;
    });
  };

  const getRelatedToOptions = (currentIndex) => {
    return salaryStructureHeadings
      .filter(heading => {
        // Exclude the current item by ID
        if (heading.id === formData[currentIndex]?.name) return false;

        const relatedEntry = formData.find(entry => entry.name === heading.id);
        if (!relatedEntry) return false;

        return (relatedEntry.fixed_amount) ||
          (relatedEntry.percentage && relatedEntry.percentage_of?.length > 0);
      })
      .sort((a, b) => a.sorting_var - b.sorting_var)
      .map(i => ({ value: i.id, label: i.title }));
  };

  const deductionIds = deductionData.map(item => item.name);


  function dependencySort(data) {
    const idToEntry = Object.fromEntries(data.map(entry => [entry.id, entry]));
    const adjacencyList = {};
    const inDegree = {};

    data.forEach(entry => {
      const id = entry.id;
      inDegree[id] = 0;
      adjacencyList[id] = [];
    });

    data.forEach(entry => {
      entry.percentage_of?.forEach(dep => {
        if (adjacencyList[dep.id]) {
          adjacencyList[dep.id].push(entry.id);
          inDegree[entry.id]++;
        }
      });
    });

    const queue = Object.keys(inDegree).filter(id => inDegree[id] === 0);
    const sorted = [];

    while (queue.length) {
      const current = queue.shift();
      sorted.push(idToEntry[current]);

      adjacencyList[current].forEach(depId => {
        inDegree[depId]--;
        if (inDegree[depId] === 0) queue.push(depId);
      });
    }

    // Handle circular dependencies or remaining items
    const remaining = Object.keys(inDegree).filter(id => inDegree[id] > 0);
    if (remaining.length) {
      console.warn("Circular dependency detected. Adding remaining unsorted items at the end.");
      remaining.forEach(id => sorted.push(idToEntry[id]));
    }

    return sorted;
  }

  let sortedData = deductionData;

  if (sortingVarBY) {
    sortedData = [...deductionData].sort((a, b) => a.name_sorting_var - b.name_sorting_var);
  } else if (deductionData.every(item => item.sorting_var !== null)) {
    sortedData = [...deductionData].sort((a, b) => a.sorting_var - b.sorting_var);
  } else {
    sortedData = dependencySort(deductionData);
  }


  return (
    <>
      <div className="">
        {deductionData.length === 0 && (
          <>
            <div className="content-tabs flex-column form-group-selectt">
              <label htmlFor="salary_policy" className="form-labels">
                Select Salary Policy
              </label>
              <br />
              <select
                name="salary_policy"
                value={selectedPolicy}
                onChange={handlePolicySelect}
                placeholder="Select a policy"
                className={`form-input form-group-selection ${errors.policy ? 'is-invalid' : ''}`}
              >
                <option value="null">Select Statuary Deduction Policy</option>
                {salaryDeductionPolicies?.map((i) => (
                  <option key={i.id} value={i.id}>{i.policy_name}</option>
                ))}
              </select>
              {/* <div className="form-group-selection-arrow">
                <DropdownArrowOption />
              </div> */}
              {errors.salary_policy && <span className="error-message">{errors.salary_policy}</span>}
            </div>
          </>
        )}

        <table className="table-css">
          <thead>
            <tr className="custom-table-head-tr">
              <th className="align-left width-5vw">Position</th>
              <th className="align-left width-5vw">Heading</th>
              <th className="align-center width-5vw">Type</th>
              <th className="align-right width-5vw">Amount</th>
              <th className="align-center" style={{ width: '0.5vw' }}>OR</th>
              <th className="align-center width-5vw">Percentage</th>
              <th className="align-center" style={{ width: '0.5vw' }}></th>
              <th className="align-center width-5vw text-left">Related To</th>
              {deductionData.length > 0 ?
                <th className="align-right width-5vw">Actual Amount</th>
                : null}
              {deductionData.length > 0 ?
                <th className="align-center width-5vw">Action</th>
                : null}
            </tr>
          </thead>
          {deductionData.length > 0 ? (
            <tbody>
              {sortedData
                // .sort((a, b) =>
                //     sortingVarBY
                //         ? a.name_sorting_var - b.name_sorting_var
                //         : a.sorting_var - b.sorting_var
                // )
                .map((entry, index) => (
                  <tr className="custom-table-head-td" key={index}>
                    <td className="align-left">{sortingVarBY ? entry.name_sorting_var : (entry.sorting_var || index + 1)}</td>
                    <td className="align-left">{entry.name_title}</td>
                    <td className="align-center form-text-trasformation-uppercase">{entry.name_type}</td>

                    <td className="align-right">{entry.fixed_amount || '-'}</td>
                    <td className="align-center">
                      <div style={{ width: '1vw' }} className="align-center width-5vw ">OR</div>
                      {/* <hr className="field-cont-hr" /> */}
                    </td>
                    <td className="align-center">
                      {entry.percentage ?
                        `${parseFloat(entry.percentage) % 1 === 0 ?
                          parseFloat(entry.percentage).toFixed(0)
                          : parseFloat(entry.percentage).toFixed(2)}%`
                        : '-'}
                    </td>
                    <td className="align-center">
                      <div style={{ width: '1vw' }} className="align-center width-5vw ">
                        {(entry.percentage || entry.percentage_of.length > 0) && 'of'}</div>
                      {/* <hr className="field-cont-hr" /> */}
                    </td>
                    <td className="align-leftt width-10vw">
                      {entry.percentage_of.length === 0 ?
                        <div className="align-center">-</div> :
                        // entry.percentage_of?.join(", ") || '-'
                        <ul style={{ paddingLeft: '0' }}>
                          {entry.percentage_of.map((data, index) => (
                            <li key={index}>
                              <span className="form-text-trasformation-uppercase">
                                {data.name}
                              </span>
                            </li>
                          ))}
                        </ul>
                      }
                    </td>
                    <td className="align-right" style={{ cursor: 'help' }} title={`Calculations:\n${getCalculatedAmount(entry, sortedData).explanation}`}>
                      {roundOffAmount ? formatRoundoffComplete(getCalculatedAmount(entry, sortedData).value || 0) : getCalculatedAmount(entry, sortedData).value}
                    </td>

                    <td className="align-center ">
                      <div className="flex-row justify-around">
                        <UpdateCustomDeductions
                          i={entry}
                          code={code}
                          deductionData={deductionData}
                          salaryStructureHeadings={salaryStructureHeadings}
                          getAllSalaryRelatedData={getAllSalaryRelatedData}
                        />
                        <DeleteCustomDeductions
                          i={entry}
                          code={code}
                          deductionData={deductionData}
                          salaryStructureHeadings={salaryStructureHeadings}
                          getAllSalaryRelatedData={getAllSalaryRelatedData}
                        />
                      </div>

                    </td>
                  </tr>
                ))}
            </tbody>
          ) : (
            <tbody>
              {formData
                ?.sort((a, b) => a.sorting_var - b.sorting_var)
                // .sort((a, b) =>
                //     sortingVarBY
                //         ? a.name_sorting_var - b.name_sorting_var
                //         : a.sorting_var - b.sorting_var
                // )
                ?.map((entry, index) => (
                  <React.Fragment key={index}>
                    <tr className="custom-table-head-td" key={index}>
                      <td className="align-left" title={`${entry.sorting_var ? 'sorting_var' : 'name_sorting_var'}`}>{entry.sorting_var || entry.name_sorting_var}</td>
                      <td>
                        <div title="Salary Heading" className="flex-column ">
                          <label
                            htmlFor={`name_${index}`}
                            className="font-weight500 font-size-heading form-text-trasformation-uppercase"
                          >
                            {salaryStructureHeadings.find(t => t.id === entry.name)?.title || "Loading..."}
                            {/* <span className="required">*</span> */}
                          </label>
                          <input
                            id={`name_${index}`}
                            name="name"
                            style={{ display: 'none' }}
                            value={salaryStructureHeadings.find(t => t.id === entry.name)?.title || "Loading..."}
                            className={`width-5vw form-input-date ${errors[`${index}_name`] ? "error" : ""}`}
                            disabled
                          />
                        </div>
                      </td>
                      <td>
                        <div title="Salary Type" className="flex-column ">
                          <label
                            htmlFor="name_type"
                            className="font-weight500 font-size-heading form-text-trasformation-uppercase"
                          >
                            {salaryStructureHeadings.find(t => t.id === entry.name)?.salary_type || "Loading..."}
                            {/* <span className="required">*</span>  */}
                          </label>
                          <input
                            id={`name_type_${index}`}
                            name="name_type"
                            style={{ display: 'none' }}
                            value={salaryStructureHeadings.find(t => t.salary_type === entry.name_type)?.salary_type || "Loading..."}
                            className={`width-5vw form-input-date ${errors[`${index}_name`] ? "error" : ""}`}
                            disabled
                          />
                        </div>
                      </td>

                      <td>
                        {entry.percentage || entry.percentage_of.length > 0 ? <div className="align-center">-</div> :
                          <div title="Fixed Amount" className="flex-column">
                            <input
                              id={`fixed_amount_${index}`}
                              name="fixed_amount"
                              placeholder="Fixed Amount"
                              type="number"
                              min={0}
                              step="0.01"
                              onWheel={(e) => e.target.blur()}
                              value={entry.fixed_amount}
                              // onChange={(e) => handleInputChange(e, index)}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*\.?\d{0,2}$/.test(value)) {
                                  handleInputChange(e, index);
                                }
                              }}
                              className={`form-input-date width-5vw ${errors[`${index}_fixed_amount`] ? "error" : ""}`}
                            />
                          </div>
                        }
                      </td>
                      <td className="align-center">
                        <div style={{ width: '1vw' }} className="align-center width-5vw ">OR</div>
                        {/* <hr className="field-cont-hr" /> */}
                      </td>
                      <td>
                        {entry.fixed_amount ? <div className="align-center">-</div> :
                          <div title="Percentage of Amount" className="flex-column form-group-selectt">
                            <input
                              id={`percentage_${index}`}
                              name="percentage"
                              type="number"
                              min={0}
                              onWheel={(e) => e.target.blur()}
                              value={entry.percentage}
                              placeholder="Percentage of Amount"
                              onChange={(e) => handleInputChange(e, index)}
                              className={`form-input-date width-5vw ${errors[`${index}_percentage`] ? "error" : ""}`}
                            />%
                          </div>
                        }
                      </td>
                      <td className="align-center">
                        <div style={{ width: '1vw' }} className="align-center width-5vw ">
                          {(entry.percentage || entry.percentage_of.length > 0) && 'of'}</div>
                        {/* <hr className="field-cont-hr" /> */}
                      </td>
                      <td>
                        {entry.fixed_amount ? <div className="align-center">-</div> :
                          <div title="Related To" className="flex-column form-group-selectt">
                            <Select
                              isMulti
                              name="percentage_of"
                              value={getRelatedToOptions(index).filter(option =>
                                entry.percentage_of?.some(po => po.id === option.value)
                              )}
                              onChange={(selectedOptions) => handleSelectChange(selectedOptions, index)}
                              options={getRelatedToOptions(index)}
                              className={`width-15vw ${errors[`${index}_percentage_of`] ? 'is-invalid' : ''}`}
                              classNamePrefix="select"
                              placeholder="Select Related To"
                              closeMenuOnSelect={false}
                              styles={{
                                control: (provided) => ({
                                  ...provided,
                                  minHeight: '50px',
                                  borderRadius: '10px',
                                  border: '1px solid #e3e3e3',
                                  margin: '10px 0px 20px 0px',
                                  color: '#4a4a4a',
                                  backgroundColor: '#f7f8fa',
                                  padding: '0px 10px',
                                }),
                                placeholder: (provided) => ({
                                  ...provided,
                                  color: '#4a4a4a',
                                }),
                                menu: (provided) => ({
                                  ...provided,
                                  borderRadius: '10px',
                                  marginTop: '0',
                                  zIndex: 9999,
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 999999,
                                }),
                                input: (provided) => ({
                                  ...provided,
                                  color: '#4a4a4a',
                                }),
                                singleValue: (provided) => ({
                                  ...provided,
                                  color: '#4a4a4a',
                                }),
                              }}
                            />
                          </div>
                        }
                      </td>
                    </tr>
                    {errors[`deduction_${index}`] && (
                      <tr>
                        <td colSpan='7' className="align-center error-message font-size-text">
                          {errors[`deduction_${index}`]}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
            </tbody>
          )}
        </table>
        <p className="error-message font-size-text">
          {isSubmitted && Object.keys(errors).length > 0 && (
            Object.keys(errors).length > 5 ? (
              <h5 className="text-center">Please fill all mandatory fields!</h5>
            ) : (

              <h6 className="text-center">
                {Object.keys(errors).map((field) =>
                  field.charAt(0).toUpperCase() + field.slice(1)
                ).join(', ') + ' are required!'}
              </h6>
            )
          )}
        </p>
        <div className="button-models">
          {deductionData.length > 0 ?
            (salaryStructureHeadings?.filter(i => !deductionIds.includes(i.id)).length > 0 ?
              <AddCustomDeductions
                code={code}
                deductionData={deductionData}
                salaryData={salaryData}
                salaryStructureHeadings={salaryStructureHeadings}
                salaryDeductionPolicies={salaryDeductionPolicies}
                getAllSalaryRelatedData={getAllSalaryRelatedData}
              /> :
              null
            )
            : (
              <button
                type="submit"
                className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                onClick={handleSubmitCustomDeduction}
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Submit Deductions'}
                {/* Incomplete Check total part om submit  */}
              </button>
            )}
        </div>
      </div>
    </>
  );
};


const UpdateCustomDeductions = ({ i, code, deductionData, salaryStructureHeadings, getAllSalaryRelatedData }) => {

  const [formData, setFormData] = useState({
    name: i.id,
    salary_structure: "",
    salary_type: i.salary_type,
    percentage: '',
    percentage_of: [],
    fixed_amount: '',
  })
  const [show, setShow] = useState(false);
  const [selectedPercentageOf, setSelectedPercentageOf] = useState([]);

  const handleShow = () => {
    const transformedData = {
      ...i,
      percentage_of: Array.isArray(i.percentage_of) ? i.percentage_of.map(item => ({
        value: item.id || item.value,
        label: item.name || item.label,
      })) : [],
    };

    setFormData(transformedData);

    setSelectedPercentageOf(transformedData.percentage_of); // Set selected items for multi-select
    // setFormData(is);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  }

  const [inputState, setInputState] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);


  const validateForm = () => {
    const newErrors = {};
    const isSalaryHeadingSelected = !!formData.name;
    const hasFixedAmount = formData.fixed_amount >= 0;
    const hasPercentage = formData.percentage !== '' && formData.percentage_of.length > 0;

    // Validate Salary Heading
    if (!isSalaryHeadingSelected) {
      newErrors.name = 'Salary Heading is required!';
    }

    // Validation for Fixed Amount or Percentage
    if (!hasFixedAmount && !hasPercentage) {
      newErrors.mixed = 'Either Fixed Amount or Percentage with Related To is required!';
    }

    // Additional validation for Fixed Amount if it's entered
    if (hasFixedAmount && !formData.fixed_amount) {
      newErrors.fixed_amount = 'Fixed Amount is required!';
    }

    // Additional validation for Percentage if it's entered
    if (hasPercentage) {
      if (!formData.percentage) {
        newErrors.percentage = 'Percentage of Amount is required!';
      }
      if (formData.percentage_of.length === 0) {
        newErrors.percentage_of = 'Related To is required!';
      }
    }

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSelectChange = (selectedOptions) => {
    setSelectedPercentageOf(selectedOptions);
    setFormData({
      ...formData,
      percentage_of: selectedOptions ? selectedOptions.map(option => ({ value: option.value, label: option.label })) : [],
    });
  };

  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    // if (!validateForm()) return;
    setLoading(true); //loading logic

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    let sucessToastId;
    const listFormData = [
      formData
    ]
    const formattedString = formData.percentage_of.join(", ");
    const formattedFormData = {
      ...formData,
      percentage_of: formattedString,
    };
    const listformattedFormData = [
      formattedFormData
    ];

    const updatedFormData = {
      ...formData,
      percentage_of: formData.percentage_of.map(item => item.label), // Only include labels in the array
    };

    try {
      let ress = await axios.put(`${BASE_URL}/siteproject/customdeduction/${i.id}/`, updatedFormData);

      if (ress.status === 200 || ress.status === 201) {
        toast.success("Updated Deduction");
        await getAllSalaryRelatedData(code);
        handleClose();

      }
      //  else {
      //     alert(ress);
      // }
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
      // toast.error("An error occurred while Updating the deduction");
    } finally {
      setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
      toast.dismiss(loadingToastId);
    }

  };
  const deductionIds = deductionData.map(item => item.name);
  const relatedToOptions = salaryStructureHeadings
    .filter(i => deductionIds.includes(i.id))
    .sort((a, b) => a.sorting_var - b.sorting_var)
    .map(i => ({ value: i.title, label: i.title }));

  const headingOptions = salaryStructureHeadings
    // .filter(i => deductionIds.includes(i.id))
    .sort((a, b) => a.sorting_var - b.sorting_var)
    .map(i => ({ value: i.id, label: i.title }));

  const relatedToHeadingOptions = [
    { value: 'Gross', label: 'Gross' },
    ...salaryStructureHeadings
      // .filter(i => !deductionIds.includes(i.id))
      .sort((a, b) => a.sorting_var - b.sorting_var)
      .map(i => ({ value: i.id, label: i.title })),
  ];

  return (
    <div>
      <>
        <button title='Update Deduction' className='model-edit-button' onClick={handleShow}>
          <UpdatePencil />
        </button>
        <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
          <Modal.Header closeButton>
            <Modal.Title>Update Deduction of : "{salaryStructureHeadings?.find(t => t.id === formData.name)?.title} ({salaryStructureHeadings?.find(t => t.id === formData.name)?.salary_type})"</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
            <form className="register-form">
              <div className="">
                {formData.percentage || formData.percentage_of.length > 0 ? "" :
                  <div className="flex-column">
                    <label className="form-labels  font-weight500 font-size-subheading">Fixed Amount<span className="required">*</span></label>
                    <input
                      type="number"
                      name="fixed_amount"
                      placeholder="Fixed Amount"
                      min={0}
                      value={formData.fixed_amount}
                      onChange={handleInputChange}
                      className={`form-input ${errors.fixed_amount ? 'is-invalid' : ''}`}
                    />
                    {errors.fixed_amount && <div className="error-message font-size-text">{errors.fixed_amount}</div>}
                  </div>
                }
                {formData.fixed_amount ? "" :
                  <>
                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">Percentage of Amount<span className="required">*</span></label>
                      <input
                        type="number"
                        name="percentage"
                        placeholder="Percentage of Amount"
                        min={0}
                        value={formData.percentage}
                        onChange={handleInputChange}
                        className={`form-input ${errors.percentage ? 'is-invalid' : ''}`}
                      />
                      {errors.percentage && <div className="error-message font-size-text">{errors.percentage}</div>}
                    </div>
                    <div title="Related To" className="flex-column ">
                      <label className="form-labels  font-weight500 font-size-subheading">Related To<span className="required">*</span></label>
                      <Select
                        isMulti
                        name="percentage_of"
                        value={selectedPercentageOf}
                        onChange={handleSelectChange}
                        options={relatedToOptions}
                        className={`width-15vw ${errors.percentage_of ? 'is-invalid' : ''}`}
                        classNamePrefix="select"
                        placeholder="Select Related To"
                        isDisabled={!!formData.fixed_amount}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            width: '33vw',
                            minHeight: '50px',
                            borderRadius: '10px',
                            border: '1px solid #e3e3e3',
                            margin: '10px 0px 20px 0px',
                            color: '#4a4a4a',
                            backgroundColor: '#f7f8fa',
                            padding: '0px 10px',
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: '#4a4a4a',
                          }),
                          menu: (provided) => ({
                            ...provided,
                            width: '33vw',
                            borderRadius: '10px',
                            marginTop: '0',
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            color: '#4a4a4a',
                          }),
                          input: (provided) => ({
                            ...provided,
                            color: '#4a4a4a',
                          }),
                        }}
                      />
                      {errors.percentage_of && <div className="error-message font-size-text">{errors.percentage_of}</div>}
                    </div>
                  </>
                }
              </div>
            </form>
            {errors.mixed && <div className="error-message font-size-text">{errors.mixed}</div>}
            <div className="button-models">
              <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Cancel
              </button>
              <button className="model-button  font-weight500  model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                {loading ? 'Updating...' : 'Update'}
              </button>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted && Object.keys(errors).length > 0 && (
                Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">Please fill all mandatory fields!</h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors).map((field) =>
                      field.charAt(0).toUpperCase() + field.slice(1)
                    ).join(', ') + ' are required!'}
                  </h6>
                )
              )}
            </p>
          </Modal.Body>
        </Modal>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>

    </div>
  )

}


const ClearCustomDeductions = ({ salary_structure, emp_code, getData, deductionData, sortingVarBY, roundOffAmount }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/bulkclearcustomdeductionbysalary_structure/${salary_structure}/`
      );

      if (res.status === 200) {
        await getData(emp_code);
        setShow(false);
        toast.dismiss(loadingToastId);
        toast.success("Salary Structure Cleared successfully");
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Salary Structure Cleared"
        className="model-button model-button-delete "
        onClick={handleShow}
      >
        Clear
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="five-sixth-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Clear Salary Breakup of "{emp_code}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete Salary structure of "{emp_code}"?
            <div className="button-models">
              <button
                className="model-button font-weight500 model-button-cancel "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button font-weight500 model-button-delete"
              >
                Clear
              </button>
            </div>
            <br />
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr">
                  <th className="align-left width-5vw">Position</th>
                  <th className="align-left width-5vw">Heading</th>
                  <th className="align-center width-5vw">Type</th>
                  <th className="align-right width-5vw">Amount</th>
                  <th className="align-center" style={{ width: '0.5vw' }}>OR</th>
                  <th className="align-center width-5vw">Percentage</th>
                  <th className="align-center width-5vw text-left">Related To</th>
                  <th className="align-right width-5vw">Actual Amount</th>

                </tr>
              </thead>
              {deductionData.length > 0 ? (
                <tbody>
                  {deductionData
                    // .sort((a, b) =>
                    //     sortingVarBY
                    //         ? a.name_sorting_var - b.name_sorting_var
                    //         : a.sorting_var - b.sorting_var
                    // )
                    .map((entry, index) => (
                      <tr className="custom-table-head-td" key={index}>
                        <td className="align-left">{sortingVarBY ? entry.name_sorting_var : (entry.sorting_var || index + 1)}</td>
                        <td className="align-left">{entry.name_title}</td>
                        <td className="align-center form-text-trasformation-uppercase">{entry.name_type}</td>

                        <td className="align-right">{entry.fixed_amount || '-'}</td>
                        <td className="align-center">
                          <div style={{ width: '1vw' }} className="align-center width-5vw ">OR</div>
                          {/* <hr className="field-cont-hr" /> */}
                        </td>
                        <td className="align-center">
                          {entry.percentage ?
                            `${parseFloat(entry.percentage) % 1 === 0 ?
                              parseFloat(entry.percentage).toFixed(0)
                              : parseFloat(entry.percentage).toFixed(2)}%`
                            : '-'}
                        </td>

                        <td className="align-leftt width-10vw">
                          {entry.percentage_of.length === 0 ?
                            <div className="align-center">-</div> :
                            // entry.percentage_of?.join(", ") || '-'
                            <ul style={{ paddingLeft: '0' }}>
                              {entry.percentage_of.map((data, index) => (
                                <li key={index}>
                                  <span className="form-text-trasformation-uppercase">
                                    {data.name}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          }
                        </td>
                        <td className="align-right" style={{ cursor: 'help' }} title={`Calculations:\n${getCalculatedAmount(entry, deductionData).explanation}`}>
                          {roundOffAmount ? formatRoundoffComplete(getCalculatedAmount(entry, deductionData).value || 0) : getCalculatedAmount(entry, deductionData).value}
                        </td>


                      </tr>
                    ))}
                </tbody>
              ) : (
                <tbody>
                  No Data
                </tbody>
              )}
            </table>

          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const DeleteCustomDeductions = ({ i, code, deductionData, salaryStructureHeadings, getAllSalaryRelatedData }) => {

  const [formData, setFormData] = useState({
    name: i.id,
    salary_structure: "",
    salary_type: i.salary_type,
    percentage: '',
    percentage_of: [],
    fixed_amount: '',
  })
  const [show, setShow] = useState(false);
  const [selectedPercentageOf, setSelectedPercentageOf] = useState([]);

  const handleShow = () => {
    const transformedData = {
      ...i,
      percentage_of: Array.isArray(i.percentage_of) ? i.percentage_of.map(item => ({
        value: item.id || item.value,
        label: item.name || item.label,
      })) : [],
    };

    setFormData(transformedData);
    setSelectedPercentageOf(transformedData.percentage_of); // Set selected items for multi-select
    // setFormData(is);
    setShow(true);


  };

  const handleClose = () => {
    setShow(false);
  }

  const [inputState, setInputState] = useState({});
  const [errors, setErrors] = useState({});



  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    // if (!validateForm()) return;
    setLoading(true); //loading logic

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    let sucessToastId;
    const listFormData = [
      formData
    ]
    const formattedString = formData.percentage_of.join(", ");
    const formattedFormData = {
      ...formData,
      percentage_of: formattedString,
    };
    const listformattedFormData = [
      formattedFormData
    ];

    const updatedFormData = {
      ...formData,
      percentage_of: formData.percentage_of.map(item => item.lable), // Only include labels in the array
    };

    try {
      let ress = await axios.delete(`${BASE_URL}/siteproject/customdeduction/${i.id}/`);

      if (ress.status === 200 || ress.status === 201) {
        toast.success("Deleted Deduction Successfully");
        await getAllSalaryRelatedData(code);
        handleClose();
      }
      //  else {
      //     alert(ress);
      // }
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
      // toast.error("An error occurred while Updating the deduction");
    } finally {
      setLoading(false); // Ensure loading state is stopped even in case of error //loading logic
      toast.dismiss(loadingToastId);
    }

  };
  const deductionIds = deductionData.map(item => item.name);
  const relatedToOptions = salaryStructureHeadings
    .filter(i => deductionIds.includes(i.id))
    .sort((a, b) => a.sorting_var - b.sorting_var)
    .map(i => ({ value: i.title, label: i.title }));


  return (
    <div>
      <>
        <button title='Delete Deduction' className='model-delete-button' onClick={handleShow}>
          <DeleteDustbin />
        </button>
        <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
          <Modal.Header closeButton>
            <Modal.Title>Delete Deduction of : "{salaryStructureHeadings?.find(t => t.id === formData.name)?.title} ({salaryStructureHeadings?.find(t => t.id === formData.name)?.salary_type})"</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
            <form className="register-form">
              <div className="">
                {formData.percentage || formData.percentage_of.length > 0 ? "" :

                  <div className="flex-column">
                    <label className="form-labels  font-weight500 font-size-subheading">Amount :</label>

                    <div className='form-labels  justify-center'>
                      {formData?.fixed_amount}
                    </div>
                  </div>
                  // <div className="flex-column">
                  //         <label className="form-labels  font-weight500 font-size-subheading">Fixed Amount<span className="required">*</span></label>
                  //         <input
                  //             type="number"
                  //             name="fixed_amount"
                  //             placeholder="Fixed Amount"
                  //             min={0}
                  //             value={formData.fixed_amount}
                  //             className={`form-input ${errors.fixed_amount ? 'is-invalid' : ''}`}
                  //         />
                  //         {errors.fixed_amount && <div className="error-message font-size-text">{errors.fixed_amount}</div>}
                  //     </div>
                }
                {formData.fixed_amount ? "" :
                  <>
                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">Percentage:</label>

                      <div className='form-labels  justify-center'>
                        {formData?.percentage}   %
                      </div>
                    </div>
                    <div title="Related To" className="flex-column ">
                      <label className="form-labels  font-weight500 font-size-subheading">Related To :</label>

                      <ul>
                        {formData?.percentage_of ?
                          formData?.percentage_of.map((item, index) => {

                            return (
                              <li key={index}>
                                {item?.label}
                              </li>)
                          }) :
                          null
                        }
                      </ul>
                      {errors.percentage_of && <div className="error-message font-size-text">{errors.percentage_of}</div>}
                    </div>
                  </>
                }
              </div>
            </form>
            {errors.mixed && <div className="error-message font-size-text">{errors.mixed}</div>}
            <div className="button-models">
              <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Cancel
              </button>
              <button className="model-button  font-weight500  model-button-delete font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                {loading ? 'Deleting...' : 'Delete'}
              </button>
            </div>

          </Modal.Body>
        </Modal>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    </div>
  )
}


const AddCustomDeductions = ({
  code,
  salaryData,
  deductionData,
  salaryStructureHeadings,
  getAllSalaryRelatedData,
}) => {

  const [formData, setFormData] = useState({
    emp_code: code,
    name: "",
    salary_structure: salaryData.id,
    salary_type: "",
    percentage: '',
    percentage_of: [], // Initialize as an array for multiple selections
    fixed_amount: '',
  });
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);


  const validateForm = () => {
    const newErrors = {};
    const isSalaryHeadingSelected = !!formData.name;
    const hasFixedAmount = formData.fixed_amount !== '';
    const hasPercentage = formData.percentage !== '' && formData.percentage_of.length > 0;

    // Validate Salary Heading
    if (!isSalaryHeadingSelected) {
      newErrors.name = 'Salary Heading is required!';
    }

    // Validation for Fixed Amount or Percentage
    if (!hasFixedAmount && !hasPercentage) {
      newErrors.mixed = 'Either Fixed Amount or Percentage with Related To is required!';
    }

    // Additional validation for Fixed Amount if it's entered
    if (hasFixedAmount && !formData.fixed_amount) {
      newErrors.fixed_amount = 'Fixed Amount is required!';
    }

    // Additional validation for Percentage if it's entered
    if (hasPercentage) {
      if (!formData.percentage) {
        newErrors.percentage = 'Percentage of Amount is required!';
      }
      if (formData.percentage_of.length === 0) {
        newErrors.percentage_of = 'Related To is required!';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Handle multiple selections for 'percentage_of'
    if (name === "percentage_of") {
      const options = Array.from(e.target.selectedOptions, option => option.value);
      setFormData({ ...formData, percentage_of: options });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    setInputState({ ...inputState, [name]: value.trim() ? "green" : "" });
  };

  const handleHeadingChange = (e) => {
    const { value } = e.target;
    const selectedHeading = salaryStructureHeadings.find(heading => heading.id === value);

    setFormData({
      ...formData,
      name: selectedHeading ? selectedHeading.id : "",
      salary_type: selectedHeading ? selectedHeading.salary_type : "",
    });

    setInputState({
      ...inputState,
      name: value.trim() ? "green" : "",
    });
  };
  const handleSelectChange = (selectedOptions) => {
    setFormData({
      ...formData,
      percentage_of: selectedOptions ? selectedOptions.map(option => option.value) : [],
    });
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    const formattedString = formData.percentage_of.join(", ");
    const formattedFormData = {
      ...formData,
      percentage_of: formattedString,
    };

    setLoading(true);
    // const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      const res = await axios.post(`${BASE_URL}/siteproject/customdeduction/`, formData);

      if (res.status === 200 || res.status === 201) {
        // toast.success("Adding Deduction");
        await getAllSalaryRelatedData(code);
        handleClose();
      } else {
        // toast.error("Error adding deduction");
        console.log("Error adding deduction");
      }
    } catch (err) {
      // toast.error("An error occurred while adding the deduction");
      console.log("An error occurred while adding the deduction");
      // handleErrorToast(err);
    } finally {
      setLoading(false);
      // toast.dismiss(loadingToastId);
      // await getAllSalaryRelatedData(code);
      // handleClose();
    }
  };
  const deductionIds = deductionData.map(item => item.name);
  const relatedToOptions = salaryStructureHeadings
    .filter(i => deductionIds.includes(i.id))
    .sort((a, b) => a.sorting_var - b.sorting_var)
    .map(i => ({ value: i.title, label: i.title }));

  const headingOptions = salaryStructureHeadings
    // .filter(i => deductionIds.includes(i.id))
    .sort((a, b) => a.sorting_var - b.sorting_var)
    .map(i => ({ value: i.id, label: i.title }));

  const relatedToHeadingOptions = [
    { value: 'Gross', label: 'Gross' },
    ...salaryStructureHeadings
      // .filter(i => !deductionIds.includes(i.id))
      .sort((a, b) => a.sorting_var - b.sorting_var)
      .map(i => ({ value: i.id, label: i.title })),
  ];

  return (
    <div>
      <button title='Add Deduction' className="model-button model-button-leave" onClick={handleShow}>
        Add
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header closeButton>
          <Modal.Title>Add Custom Deduction</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
          <form className="register-form" onSubmit={handleFormSubmit}>
            <div className="form-flex-wrap">
              <div title="Salary Structure Heading" className="flex-column form-group-selectt">
                <label htmlFor="name" className="form-labels font-weight500 font-size-subheading">
                  Salary Structure Heading<span className="required">*</span>
                </label>
                <br />
                <select
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleHeadingChange}
                  className={`form-input form-group-selection ${errors.name ? "error" : inputState.name ? "success" : ""}`}
                >
                  <option value="">Select Salary Heading</option>
                  {salaryStructureHeadings
                    ?.filter(i => !deductionIds.includes(i.id))
                    .map((i) => (
                      <option key={i.id} value={i.id}>
                        {i.title}
                      </option>
                    ))}
                </select>
                {/* <br /> */}
                <div>
                  {errors.name && <span className="error-message font-size-text">{errors.name}</span>}
                </div>
              </div>

              {formData.percentage || formData.percentage_of.length > 0 ? null : (
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">
                    Fixed Amount<span className="required">*</span>
                  </label>
                  <input
                    type="number"
                    name="fixed_amount"
                    placeholder="Fixed Amount"
                    min={0}
                    value={formData.fixed_amount}
                    onChange={handleInputChange}
                    className={`form-input ${errors.fixed_amount ? 'is-invalid' : ''}`}
                  />
                  {errors.fixed_amount && <div className="error-message font-size-text">{errors.fixed_amount}</div>}
                </div>
              )}
              {formData.fixed_amount ? null : (
                <>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Percentage of Amount<span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      name="percentage"
                      placeholder="Percentage of Amount"
                      min={0}
                      step={0.01}
                      value={formData.percentage}
                      onChange={handleInputChange}
                      className={`form-input ${errors.percentage ? 'is-invalid' : ''}`}
                    />
                    {errors.percentage && <div className="error-message font-size-text">{errors.percentage}</div>}
                  </div>

                  <div title="Related To" className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Related To<span className="required">*</span>
                    </label>
                    <Select
                      isMulti
                      name="percentage_of"
                      value={relatedToOptions.filter(option => formData.percentage_of?.includes(option.value))}
                      onChange={(selectedOptions) => handleSelectChange(selectedOptions)}
                      options={relatedToOptions}
                      className={`width-15vw ${errors.percentage_of ? 'is-invalid' : ''}`}
                      classNamePrefix="select"
                      placeholder="Select Related To"
                      isDisabled={!!formData.fixed_amount} // Disable if fixed amount is provided
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: '33vw',
                          minHeight: '50px',
                          borderRadius: '10px',
                          border: '1px solid #e3e3e3',
                          margin: '10px 0px 20px 0px',
                          color: '#4a4a4a',
                          backgroundColor: '#f7f8fa',
                          padding: '0px 10px',
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: '#4a4a4a',
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: '33vw',
                          borderRadius: '10px',
                          marginTop: '0',
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          color: '#4a4a4a',
                        }),
                        input: (provided) => ({
                          ...provided,
                          color: '#4a4a4a',
                        }),
                      }}
                    />
                    {errors.percentage_of && <div className="error-message font-size-text">{errors.percentage_of}</div>}
                  </div>
                </>
              )}
            </div>
            {errors.mixed && <div className="error-message font-size-text">{errors.mixed}</div>}
            <div className="button-models">
              <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Cancel
              </button>
              <button className="model-button font-weight500 model-button-leave font-size-heading" disabled={loading}>
                {loading ? 'Adding...' : 'Add'}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

// ! ***************  SalaryDeductionPolicy Crud Models Start ***************

const SalaryDeductionPolicyAdd = ({ getSalaryDeductionPolicyList }) => {
  const [show, setShow] = useState(false);
  const { SUB_COMPANIES } = usePermission();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    name: '',
    epf: false,
    epf_criteria: '',
    epf_employee: false,
    epf_employer: false,
    epf_employee_rate: '',
    epf_employer_rate: '',
    esi: false,
    esi_criteria: '',
    esi_employee: false,
    esi_employer: false,
    esi_employee_rate: '',
    esi_employer_rate: '',
    sub_company: '',
  });

  // Validation
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      'name',
      'epf_criteria',
      'epf_employee_rate',
      'epf_employer_rate',
      'esi_criteria',
      'esi_employee_rate',
      'esi_employer_rate',
      'sub_company',
    ];


    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    // // Add more validation for numerical fields as needed
    // if (formData.epf_criteria && isNaN(formData.epf_criteria)) {
    //   newErrors.epf_criteria = 'EPF criteria must be a valid number!';
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading('Loading: Please wait...');
      setLoading(true); //loading logic
      try {
        let res = await axios.post(`${BASE_URL}/siteproject/salarypolicy/`, formData);
        if (res.status === 200) {
          await getSalaryDeductionPolicyList();
          setShow(false);
          // toast.success('Salary Policy created successfully!');
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false); //loading logic
      }
    }
  };

  return (
    <>
      <button className="upload-svg" title="Add Salary Deduction Policy" onClick={handleShow}>
        <AddwithWhiteCircle />
        {" "} Salary Deduction Policy
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">

        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Add Salary Deduction Policy</Modal.Title></h1>
              <div className="flex-column">
                <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading" title="Name">
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  title="Name"
                  name="name"
                  placeholder="Salary Deduction Policy Name"
                  onChange={handleInputChange}
                  value={formData.name}
                  className={`form-input ${errors.name ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.name && (
                  <span className="error-message font-size-text ">{errors.name}</span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading" title="Sub Company">
                  Sub Company<span className="required">*</span>
                </label>
                <select
                  id="sub_company"
                  name="sub_company"
                  title="Sub Company"
                  value={formData.sub_company}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                    }`}
                >
                  <option value='' title="Select Sub Company">Select Sub Company</option>
                  {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                </select>
                {errors.sub_company && (
                  <span className="error-message font-size-text ">{errors.sub_company}</span>
                )}
              </div>

              <div className="flex-row">
                <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading" title="EPF">
                  EPF
                </label>
                <input
                  type="checkbox"
                  name="epf"
                  title="EPF"
                  onChange={handleInputChange}
                  checked={formData.epf}
                  className={`inputform-checkbox`}
                />
              </div>
              <div className="flex-column">
                <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading" title="EPF Criteria">
                  EPF Criteria
                </label>
                <input
                  id="epf_criteria"
                  name="epf_criteria"
                  title="EPF Criteria"
                  value={formData.epf_criteria}
                  placeholder="00000.00"
                  type="number"
                  min={0}
                  maxLength={5}
                  step="0.01"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const value = e.target.value;
                    const regex = /^\d{0,5}(\.\d{0,2})?$/;
                    if (regex.test(value) || value === "") {
                      handleInputChange(e); // Only update if the input matches the pattern
                    }
                  }}
                  // onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.epf_criteria ? "error" : inputState.epf_criteria ? "success" : ""
                    }`}
                >
                </input>
                {errors.epf_criteria && (
                  <span className="error-message font-size-text ">{errors.epf_criteria}</span>
                )}
              </div>
              <div className="flex-row justify-between">
                <div className="flex-column">
                  <div className="flex-row">
                    <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading" title="Employee Contribution">
                      Employee Contribution
                    </label>
                    <input
                      type="checkbox"
                      name="epf_employee"
                      title="Employee Contribution"
                      onChange={handleInputChange}
                      checked={formData.epf_employee}
                      className={`inputform-checkbox`}
                    />
                  </div>
                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label className="form-labels  font-weight500    font-size-subheading" title="Employee Rate">
                        Employee Rate
                      </label>
                      <input
                        id="epf_employee_rate"
                        name="epf_employee_rate"
                        title="Employee Rate"
                        value={formData.epf_employee_rate}
                        placeholder="0.00"
                        type="number"
                        min={0}
                        maxLength={5}
                        step="0.0001"
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          const value = e.target.value;
                          const regex = /^\d{0,5}(\.\d{0,4})?$/;
                          if (regex.test(value) || value === "") {
                            handleInputChange(e); // Only update if the input matches the pattern
                          }
                        }}
                        // onChange={handleInputChange}
                        className={`multi-day-input1 form-input-background`}
                      />
                      <br />
                      {errors.epf_employee_rate && (
                        <span className="error-message font-size-text ">{errors.epf_employee_rate}</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex-column">
                  <div className="flex-row">
                    <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading" title="Employer Contribution">
                      Employer Contribution
                    </label>
                    <input
                      type="checkbox"
                      title="Employer Contribution"
                      name="epf_employer"
                      checked={formData.epf_employer}
                      onChange={handleInputChange}
                      className={`inputform-checkbox`}
                    />
                  </div>

                  <div className="flex-column">
                    <label htmlFor="epf_employer_rate" className="form-labels  font-weight500    font-size-subheading" title="Employer Rate">
                      Employer  Rate
                    </label>
                    <input
                      id="epf_employer_rate"
                      name="epf_employer_rate"
                      title="Employer Rate"
                      value={formData.epf_employer_rate}
                      placeholder="0.00"
                      type="number"
                      min={0}
                      maxLength={5}
                      step="0.0001"
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => {
                        const value = e.target.value;
                        const regex = /^\d{0,5}(\.\d{0,4})?$/;
                        if (regex.test(value) || value === "") {
                          handleInputChange(e); // Only update if the input matches the pattern
                        }
                      }}
                      // onChange={handleInputChange}
                      className={`multi-day-input1 form-input-background`}
                    />
                    <br />
                    {errors.epf_employer_rate && (
                      <span className="error-message font-size-text ">{errors.epf_employer_rate}</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex-row">
                <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading" title="ESI">
                  ESI
                </label>
                <input
                  type="checkbox"
                  name="esi"
                  title="ESI"
                  onChange={handleInputChange}
                  checked={formData.esi}
                  className={`inputform-checkbox`}
                />
              </div>
              <div className="flex-column">
                <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading" title="ESI Creteria">
                  ESI Criteria
                </label>
                <input
                  id="esi_criteria"
                  name="esi_criteria"
                  title="ESI Criteria"
                  value={formData.esi_criteria}
                  placeholder="00000.00"
                  type="number"
                  min={0}
                  maxLength={5}
                  step="0.01"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const value = e.target.value;
                    const regex = /^\d{0,5}(\.\d{0,2})?$/;
                    if (regex.test(value) || value === "") {
                      handleInputChange(e); // Only update if the input matches the pattern
                    }
                  }}
                  // onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.esi_criteria ? "error" : inputState.esi_criteria ? "success" : ""
                    }`}
                >
                </input>
                {errors.esi_criteria && (
                  <span className="error-message font-size-text ">{errors.esi_criteria}</span>
                )}
              </div>
              <div className="flex-row justify-between">
                <div className="flex-column">
                  <div className="flex-row">
                    <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading" title="Employee Contribution">
                      Employee Contribution
                    </label>
                    <input
                      type="checkbox"
                      name="esi_employee"
                      title="Employee Contribution"
                      onChange={handleInputChange}
                      checked={formData.esi_employee}
                      className={`inputform-checkbox`}
                    />
                  </div>
                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label className="form-labels  font-weight500    font-size-subheading" title="Employee Rate">
                        Employee Rate
                      </label>
                      <input
                        id="esi_employee_rate"
                        name="esi_employee_rate"
                        title="Employee Rate"
                        value={formData.esi_employee_rate}
                        placeholder="0.00"
                        type="number"
                        min={0}
                        maxLength={5}
                        step="0.0001"
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          const value = e.target.value;
                          const regex = /^\d{0,5}(\.\d{0,4})?$/;
                          if (regex.test(value) || value === "") {
                            handleInputChange(e); // Only update if the input matches the pattern
                          }
                        }}
                        // onChange={handleInputChange}
                        className={`multi-day-input1 form-input-background`}
                      />
                      <br />
                      {errors.esi_employee_rate && (
                        <span className="error-message font-size-text ">{errors.esi_employee_rate}</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex-column">
                  <div className="flex-row">
                    <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading" title="Employer Contribution">
                      Employer Contribution
                    </label>
                    <input
                      type="checkbox"
                      name="esi_employer"
                      title="Employer Contribution"
                      onChange={handleInputChange}
                      checked={formData.esi_employer}
                      className={`inputform-checkbox`}
                    />
                  </div>

                  <div className="flex-column">
                    <label htmlFor="esi_employer_rate" className="form-labels  font-weight500    font-size-subheading" title="Employer Rate">
                      Employer Rate
                    </label>
                    <input
                      id="esi_employer_rate"
                      name="esi_employer_rate"
                      title="Employer Rate"
                      value={formData.esi_employer_rate}
                      placeholder="0.00"
                      type="number"
                      min={0}
                      maxLength={5}
                      step="0.0001"
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => {
                        const value = e.target.value;
                        const regex = /^\d{0,5}(\.\d{0,4})?$/;
                        if (regex.test(value) || value === "") {
                          handleInputChange(e); // Only update if the input matches the pattern
                        }
                      }}
                      // onChange={handleInputChange}
                      className={`multi-day-input1 form-input-background`}
                    />
                    <br />
                    {errors.esi_employer_rate && (
                      <span className="error-message font-size-text ">{errors.esi_employer_rate}</span>
                    )}
                  </div>
                </div>
              </div>


              <div className="button-models">
                <button className="model-button model-button-cancel  font-weight500   " onClick={handleClose}>
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Add
                </button>
              </div>
            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};


const SalaryDeductionPolicyUpdate = ({ i, getSalaryDeductionPolicyList }) => {
  const [show, setShow] = useState(false);
  const { SUB_COMPANIES } = usePermission();

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setFormData(i);
    setShow(true);
    console.log(SUB_COMPANIES)
  };

  const [formData, setFormData] = useState({
    name: '',
    epf: false,
    epf_criteria: '',
    epf_employee: false,
    epf_employer: false,
    epf_employee_rate: '',
    epf_employer_rate: '',
    esi: false,
    esi_criteria: '',
    esi_employee: false,
    esi_employer: false,
    esi_employee_rate: '',
    esi_employer_rate: '',
    sub_company: '',
  });
  console.log("formData")
  console.log(formData)
  // Validation
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      'name',
      'epf_criteria',
      'epf_employee_rate',
      'epf_employer_rate',
      'esi_criteria',
      'esi_employee_rate',
      'esi_employer_rate',
      'sub_company',
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });



    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setInputState({
      ...inputState,
      [name]: type === "checkbox" ? "green" : value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading('Loading: Please wait...');
      setLoading(true); //loading logic
      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/salarypolicy/${i.id}/`,
          formData
        );
        if (res.status === 200) {
          await getSalaryDeductionPolicyList();
          setShow(false);
        }
      } catch (err) {
        handleErrorToast(err, loadingToastId)
      } finally {
        toast.dismiss(loadingToastId);
        setLoading(false); //loading logic
      }
    }
  };

  return (
    <>
      <button className="model-edit-button" title="Update Salary Deduction Policy" onClick={handleShow}>
        <UpdatePencil />
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">

        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Update Salary Deduction Policy: <br />{i.name}</Modal.Title></h1>
              <div className="flex-column">
                <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading">
                  Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Salary Deduction Policy Name"
                  onChange={handleInputChange}
                  value={formData.name}
                  className={`form-input ${errors.name ? "error" : inputState.tile ? "success" : ""
                    }`}
                />
                {errors.name && (
                  <span className="error-message font-size-text ">{errors.name}</span>
                )}
              </div>

              <div className="flex-column">
                <label htmlFor="sub_company" className="form-labels  font-weight500    font-size-subheading">
                  Sub Company<span className="required">*</span>
                </label>
                <select
                  id="sub_company"
                  name="sub_company"
                  value={formData.sub_company}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""
                    }`}
                >
                  <option value=''>Select Sub Company</option>
                  {SUB_COMPANIES.map(company => (<option value={company.id}>{company.title}</option>))};
                </select>
                {errors.sub_company && (
                  <span className="error-message font-size-text ">{errors.sub_company}</span>
                )}
              </div>

              <div className="flex-row">
                <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading">
                  EPF
                </label>
                <input
                  type="checkbox"
                  name="epf"
                  onChange={handleInputChange}
                  checked={formData.epf}
                  className={`inputform-checkbox`}
                />
              </div>
              <div className="flex-column">
                <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading">
                  EPF Criteria
                </label>
                <input
                  id="epf_criteria"
                  name="epf_criteria"
                  value={formData.epf_criteria}
                  placeholder="00000.00"
                  type="number"
                  min={0}
                  maxLength={5}
                  step="0.01"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const value = e.target.value;
                    const regex = /^\d{0,5}(\.\d{0,2})?$/;
                    if (regex.test(value) || value === "") {
                      handleInputChange(e); // Only update if the input matches the pattern
                    }
                  }}
                  // onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.epf_criteria ? "error" : inputState.epf_criteria ? "success" : ""
                    }`}
                >
                </input>
                {errors.epf_criteria && (
                  <span className="error-message font-size-text ">{errors.epf_criteria}</span>
                )}
              </div>
              <div className="flex-row justify-between">
                <div className="flex-column">
                  <div className="flex-row">
                    <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading">
                      Employee Contribution
                    </label>
                    <input
                      type="checkbox"
                      name="epf_employee"
                      onChange={handleInputChange}
                      checked={formData.epf_employee}
                      className={`inputform-checkbox`}
                    />
                  </div>
                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label className="form-labels  font-weight500    font-size-subheading">
                        Employee Rate
                      </label>
                      <input
                        id="epf_employee_rate"
                        name="epf_employee_rate"
                        value={formData.epf_employee_rate}
                        placeholder="0.00"
                        type="number"
                        min={0}
                        maxLength={5}
                        step="0.0001"
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          const value = e.target.value;
                          const regex = /^\d{0,5}(\.\d{0,4})?$/;
                          if (regex.test(value) || value === "") {
                            handleInputChange(e); // Only update if the input matches the pattern
                          }
                        }}
                        // onChange={handleInputChange}
                        className={`multi-day-input1 form-input-background`}
                      />
                      <br />
                      {errors.epf_employee_rate && (
                        <span className="error-message font-size-text ">{errors.epf_employee_rate}</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex-column">
                  <div className="flex-row">
                    <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading">
                      Employer Contribution
                    </label>
                    <input
                      type="checkbox"
                      name="epf_employer"
                      checked={formData.epf_employer}
                      onChange={handleInputChange}
                      className={`inputform-checkbox`}
                    />
                  </div>

                  <div className="flex-column">
                    <label htmlFor="epf_employer_rate" className="form-labels  font-weight500    font-size-subheading">
                      Employer  Rate
                    </label>
                    <input
                      id="epf_employer_rate"
                      name="epf_employer_rate"
                      value={formData.epf_employer_rate}
                      placeholder="0.00"
                      type="number"
                      min={0}
                      maxLength={5}
                      step="0.0001"
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => {
                        const value = e.target.value;
                        const regex = /^\d{0,5}(\.\d{0,4})?$/;
                        if (regex.test(value) || value === "") {
                          handleInputChange(e); // Only update if the input matches the pattern
                        }
                      }}
                      // onChange={handleInputChange}
                      className={`multi-day-input1 form-input-background`}
                    />
                    <br />
                    {errors.epf_employer_rate && (
                      <span className="error-message font-size-text ">{errors.epf_employer_rate}</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex-row">
                <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading">
                  ESI
                </label>
                <input
                  type="checkbox"
                  name="esi"
                  onChange={handleInputChange}
                  checked={formData.esi}
                  className={`inputform-checkbox`}
                />
              </div>
              <div className="flex-column">
                <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading">
                  ESI Criteria
                </label>
                <input
                  id="esi_criteria"
                  name="esi_criteria"
                  value={formData.esi_criteria}
                  placeholder="00000.00"
                  type="number"
                  min={0}
                  maxLength={5}
                  step="0.01"
                  onWheel={(e) => e.target.blur()}
                  onChange={(e) => {
                    const value = e.target.value;
                    const regex = /^\d{0,5}(\.\d{0,2})?$/;
                    if (regex.test(value) || value === "") {
                      handleInputChange(e); // Only update if the input matches the pattern
                    }
                  }}
                  // onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.esi_criteria ? "error" : inputState.esi_criteria ? "success" : ""
                    }`}
                >
                </input>
                {errors.esi_criteria && (
                  <span className="error-message font-size-text ">{errors.esi_criteria}</span>
                )}
              </div>
              <div className="flex-row justify-between">
                <div className="flex-column">
                  <div className="flex-row">
                    <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading">
                      Employee Contribution
                    </label>
                    <input
                      type="checkbox"
                      name="esi_employee"
                      onChange={handleInputChange}
                      checked={formData.esi_employee}
                      className={`inputform-checkbox`}
                    />
                  </div>
                  <div className="flex-row policy-input width-15vw">
                    <div className="flex-column multi-day">
                      <label className="form-labels  font-weight500    font-size-subheading">
                        Employee Rate
                      </label>
                      <input
                        id="esi_employee_rate"
                        name="esi_employee_rate"
                        value={formData.esi_employee_rate}
                        placeholder="0.00"
                        type="number"
                        min={0}
                        maxLength={5}
                        step="0.0001"
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          const value = e.target.value;
                          const regex = /^\d{0,5}(\.\d{0,4})?$/;
                          if (regex.test(value) || value === "") {
                            handleInputChange(e); // Only update if the input matches the pattern
                          }
                        }}
                        // onChange={handleInputChange}
                        className={`multi-day-input1 form-input-background`}
                      />
                      <br />
                      {errors.esi_employee_rate && (
                        <span className="error-message font-size-text ">{errors.esi_employee_rate}</span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex-column">
                  <div className="flex-row">
                    <label htmlFor="name" className="form-labels  font-weight500    font-size-subheading">
                      Employer Contribution
                    </label>
                    <input
                      type="checkbox"
                      name="esi_employer"
                      onChange={handleInputChange}
                      checked={formData.esi_employer}
                      className={`inputform-checkbox`}
                    />
                  </div>

                  <div className="flex-column">
                    <label htmlFor="esi_employer_rate" className="form-labels  font-weight500    font-size-subheading">
                      Employer Rate
                    </label>
                    <input
                      id="esi_employer_rate"
                      name="esi_employer_rate"
                      value={formData.esi_employer_rate}
                      placeholder="0.00"
                      type="number"
                      min={0}
                      maxLength={5}
                      step="0.0001"
                      onWheel={(e) => e.target.blur()}
                      onChange={(e) => {
                        const value = e.target.value;
                        const regex = /^\d{0,5}(\.\d{0,4})?$/;
                        if (regex.test(value) || value === "") {
                          handleInputChange(e); // Only update if the input matches the pattern
                        }
                      }}
                      // onChange={handleInputChange}
                      className={`multi-day-input1 form-input-background`}
                    />
                    <br />
                    {errors.esi_employer_rate && (
                      <span className="error-message font-size-text ">{errors.esi_employer_rate}</span>
                    )}
                  </div>
                </div>
              </div>

              <div className="button-models">
                <button className="model-button model-button-cancel  font-weight500   " onClick={handleClose}>
                  Cancel
                </button>
                <button
                  //   type="submit"
                  className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                  onClick={handleFormSubmit}
                  disabled={loading}
                >
                  Update
                </button>
              </div>
            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};


const SalaryDeductionPolicyDelete = ({ i, getSalaryDeductionPolicyList }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    try {
      let res = await axios.delete(`${BASE_URL}/siteproject/salarypolicy/${i.id}/`);

      if (res.status === 200) {
        await getSalaryDeductionPolicyList();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err, loadingToastId)
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="model-delete-button" title="Delete Salary Deduction Policy" onClick={handleShow}>
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Delete Salary Deduction Policy : {i.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to Delete Salary Deduction Policy : {i.name}
            <div className="button-models">
              <button className="model-button   font-weight500    " onClick={handleClose}>
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};


const AddSalaryStructurePolicyFormat = ({ getSalaryStructureFormat }) => {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState({
    policy_name: "",
    sub_company: "",
    salaryPolicyDeductionsFormat: []
  });
  const [addMode, setAddMode] = useState('bulk'); // 'bulk' or 'single'

  const { SUB_COMPANIES, PERMISSION_AUTHORITY } = usePermission();
  const [loading, setLoading] = useState(false);

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const [salaryDeductionPolicies, setSalaryDeductionPolicy] = useState([]);
  const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = async () => {
    // await getAllSalaryRelatedData();
    setShow(true);
  };

  const [buffer, setBuffering] = useState(false); //buffering logic
  const getAllSalaryRelatedData = async (emp_code) => {
    setBuffering(true); // Start Buffering
    try {
      const policies = await axios.get(`${BASE_URL}/siteproject/salarypolicybysubcompany/${formData.sub_company}/`);
      setSalaryDeductionPolicy(policies.data);

      const headings = await axios.get(`${BASE_URL}/siteproject/salaryHeadingbysubcompany/${formData.sub_company}/`);

      if (Array.isArray(headings.data)) {
        setSalaryStructureHeadings(headings.data);

        console.log('headings.data')
        console.log(headings.data)

        const salaryPolicyDeductionsFormat = headings.data.map(item => ({
          name: item.id,
          sorting_var: item.sorting_var,
          percentage: '',
          percentage_of: [],
          fixed_amount: '',
          useFixedAmount: false,
          usePercentage: false
        }));

        setFormData(prev => ({
          ...prev,
          salaryPolicyDeductionsFormat
        }));
      } else {
        console.error("Error: Expected a list of Salary Headings");
      }
    } catch (err) {
      if (show) {
        if (formData.sub_company) {
          handleErrorToast(err)
        }
        else {
          toast.warning("Please Select Subcompany First");
        }
      }
    } finally {
      setBuffering(false);// End Buffering
    }
  };

  useEffect(() => {
    getAllSalaryRelatedData();
  }, [formData.sub_company]);

  const inputRefs = useRef([]);
  const [focusedInput, setFocusedInput] = useState(null);
  const [prevSortingVars, setPrevSortingVars] = useState([]);

  useEffect(() => {
    inputRefs.current = inputRefs.current.slice(0, formData.salaryPolicyDeductionsFormat.length);
    setPrevSortingVars(formData.salaryPolicyDeductionsFormat.map(item => item.sorting_var));
  }, [formData.salaryPolicyDeductionsFormat]);

  const handleFocus = (index) => {
    const input = inputRefs.current[index];
    if (input) {
      setFocusedInput({
        sorting_var: formData.salaryPolicyDeductionsFormat[index].sorting_var,
        cursorPos: input.selectionStart
      });
    }
  };

  // console.log("focusedInput", focusedInput)

  useEffect(() => {
    if (!focusedInput) return;

    const newIndex = formData.salaryPolicyDeductionsFormat.findIndex(
      item => item.sorting_var === focusedInput.sorting_var
    );

    if (newIndex !== -1 && inputRefs.current[newIndex]) {
      const input = inputRefs.current[newIndex];
      input.focus();

      // Only set cursor position if we have a valid position
      if (focusedInput.cursorPos !== null && focusedInput.cursorPos !== undefined) {
        input.setSelectionRange(
          focusedInput.cursorPos,
          focusedInput.cursorPos
        );
      }
    }
  }, [formData.salaryPolicyDeductionsFormat, focusedInput]);



  const handlePositionChange = (e, index) => {
    const newPosition = parseInt(e.target.value);
    const oldPosition = parseInt(formData.salaryPolicyDeductionsFormat[index].sorting_var);

    if (newPosition === oldPosition) return;

    setFormData(prev => {
      const updatedFormat = [...prev.salaryPolicyDeductionsFormat];

      // First update the current item's position
      updatedFormat[index] = {
        ...updatedFormat[index],
        sorting_var: newPosition.toString() // Keep as string for consistency
      };

      // Create a map of current positions
      const positionMap = {};
      updatedFormat.forEach((item, i) => {
        positionMap[i] = parseInt(item.sorting_var);
      });

      if (newPosition < oldPosition) {
        // Moving to a lower position (e.g., from 8 to 2)
        // Increment positions that are >= newPosition and < oldPosition
        updatedFormat.forEach((item, i) => {
          const currentPos = parseInt(item.sorting_var);
          if (i !== index &&
            currentPos >= newPosition &&
            currentPos < oldPosition) {
            item.sorting_var = (currentPos + 1).toString();
          }
        });
      } else {
        // Moving to a higher position (e.g., from 2 to 5)
        // Decrement positions that are > oldPosition and <= newPosition
        updatedFormat.forEach((item, i) => {
          const currentPos = parseInt(item.sorting_var);
          if (i !== index &&
            currentPos > oldPosition &&
            currentPos <= newPosition) {
            item.sorting_var = (currentPos - 1).toString();
          }
        });
      }

      // Ensure all positions are unique and sequential
      const sortedItems = [...updatedFormat].sort((a, b) =>
        parseInt(a.sorting_var) - parseInt(b.sorting_var)
      );

      // Reassign positions sequentially to fix any gaps
      sortedItems.forEach((item, i) => {
        item.sorting_var = (i + 1).toString();
      });

      return {
        ...prev,
        salaryPolicyDeductionsFormat: sortedItems
      };
    });
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;

    const currentInput = inputRefs.current[index];
    const cursorPos = currentInput?.selectionStart;

    setFormData(prev => {
      const updatedSalaryPolicyDeductionsFormat = [...prev.salaryPolicyDeductionsFormat];


      if (name === "fixed_amount") {
        updatedSalaryPolicyDeductionsFormat[index] = {
          ...updatedSalaryPolicyDeductionsFormat[index],
          fixed_amount: value,
          useFixedAmount: true,
          usePercentage: false,
          percentage: '',
          percentage_of: []
        };
      } else if (name === "percentage") {
        updatedSalaryPolicyDeductionsFormat[index] = {
          ...updatedSalaryPolicyDeductionsFormat[index],
          percentage: value,
          usePercentage: true,
          useFixedAmount: false,
          fixed_amount: ''
        };
      }
      // else if (name === "sorting_var") {
      //     updatedSalaryPolicyDeductionsFormat[index] = {
      //         ...updatedSalaryPolicyDeductionsFormat[index],
      //         [name]: value
      //     };

      //     setFocusedInput({
      //         sorting_var: value, // Track the new value
      //         cursorPos: cursorPos
      //     });
      // }
      else {
        updatedSalaryPolicyDeductionsFormat[index] = {
          ...updatedSalaryPolicyDeductionsFormat[index],
          [name]: value
        };
      }

      return {
        ...prev,
        salaryPolicyDeductionsFormat: updatedSalaryPolicyDeductionsFormat
      };
    });
  };

  const handleCheckboxChange = (type, index) => {
    setFormData(prev => {
      const updatedSalaryPolicyDeductionsFormat = [...prev.salaryPolicyDeductionsFormat];

      if (type === 'fixed') {
        updatedSalaryPolicyDeductionsFormat[index] = {
          ...updatedSalaryPolicyDeductionsFormat[index],
          useFixedAmount: !updatedSalaryPolicyDeductionsFormat[index].useFixedAmount,
          usePercentage: updatedSalaryPolicyDeductionsFormat[index].useFixedAmount ? false : updatedSalaryPolicyDeductionsFormat[index].usePercentage,
          fixed_amount: updatedSalaryPolicyDeductionsFormat[index].useFixedAmount ? '' : '0',
          percentage: updatedSalaryPolicyDeductionsFormat[index].useFixedAmount ? updatedSalaryPolicyDeductionsFormat[index].percentage : '',
          percentage_of: updatedSalaryPolicyDeductionsFormat[index].useFixedAmount ? updatedSalaryPolicyDeductionsFormat[index].percentage_of : []
        };
      } else if (type === 'percentage') {
        updatedSalaryPolicyDeductionsFormat[index] = {
          ...updatedSalaryPolicyDeductionsFormat[index],
          usePercentage: !updatedSalaryPolicyDeductionsFormat[index].usePercentage,
          useFixedAmount: updatedSalaryPolicyDeductionsFormat[index].usePercentage ? false : updatedSalaryPolicyDeductionsFormat[index].useFixedAmount,
          percentage: updatedSalaryPolicyDeductionsFormat[index].usePercentage ? '' : '0',
          percentage_of: updatedSalaryPolicyDeductionsFormat[index].usePercentage ? [] : updatedSalaryPolicyDeductionsFormat[index].percentage_of,
          fixed_amount: updatedSalaryPolicyDeductionsFormat[index].usePercentage ? updatedSalaryPolicyDeductionsFormat[index].fixed_amount : ''
        };
      }

      return {
        ...prev,
        salaryPolicyDeductionsFormat: updatedSalaryPolicyDeductionsFormat
      };
    });
  };

  const handleSelectChange = (selectedOptions, index) => {
    setFormData(prev => {
      const updatedSalaryPolicyDeductionsFormat = [...prev.salaryPolicyDeductionsFormat];

      updatedSalaryPolicyDeductionsFormat[index] = {
        ...updatedSalaryPolicyDeductionsFormat[index],
        percentage_of: selectedOptions ? selectedOptions.map(option => option.value) : [],
      };

      return {
        ...prev,
        salaryPolicyDeductionsFormat: updatedSalaryPolicyDeductionsFormat
      };
    });
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "policy_name",
      "sub_company",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    const hasValidDeductions = formData.salaryPolicyDeductionsFormat.some(entry =>
      (entry.useFixedAmount && entry.fixed_amount) ||
      (entry.usePercentage && entry.percentage && entry.percentage_of.length > 0)
    );

    if (!hasValidDeductions) {
      newErrors.deductions = "Atleast 1 Deduction  is required";
    }

    // Validate each policy format
    formData.salaryPolicyDeductionsFormat.forEach((entry, index) => {
      if (entry.useFixedAmount && entry.usePercentage) {
        newErrors[`policy_${index}`] = "Cannot use both Fixed Amount and Percentage";
      } else if (entry.usePercentage && (!entry.percentage || entry.percentage_of.length === 0)) {
        newErrors[`policy_${index}`] = "Percentage and Related To are required when using Percentage";
      } else if (entry.useFixedAmount && !entry.fixed_amount) {
        newErrors[`policy_${index}`] = "Fixed Amount is required";
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // console.log("validateForm-", validateForm)
    if (!validateForm()) return;

    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      // Filter out entries that don't have either fixed amount or percentage set
      const validPolicyFormat = formData.salaryPolicyDeductionsFormat.filter(entry =>
        (entry.useFixedAmount && entry.fixed_amount) ||
        (entry.usePercentage && entry.percentage && entry.percentage_of.length > 0)
      );

      const payload = {
        ...formData,
        salaryPolicyDeductionsFormat: validPolicyFormat.map(entry => ({
          ...entry,
          // Remove the UI control fields before sending
          useFixedAmount: undefined,
          usePercentage: undefined
        }))
      };

      console.log("payload-", payload)
      const res = await axios.post(`${BASE_URL}/siteproject/salarypolicywithcustomdeductions/`, payload);

      if (res.status === 200 || res.status === 201) {
        toast.success("Salary structure saved successfully.");
        getSalaryStructureFormat();
        handleClose();
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };


  const getRelatedToOptions = (currentIndex) => {
    const currentPosition = parseInt(formData.salaryPolicyDeductionsFormat[currentIndex]?.sorting_var) || 0;

    return salaryStructureHeadings
      .filter(heading => {
        if (heading.id === formData.salaryPolicyDeductionsFormat[currentIndex]?.name) return false;
        const policy = formData.salaryPolicyDeductionsFormat.find(p => p.name === heading.id);
        if (!policy) return false;
        const headingPosition = parseInt(policy.sorting_var) || 0;
        return (
          headingPosition < currentPosition &&
          (
            (policy.useFixedAmount && policy.fixed_amount) ||
            (policy.usePercentage && policy.percentage && policy.percentage_of.length > 0)
          )
        );
      })
      .sort((a, b) => parseInt(a.sorting_var) - parseInt(b.sorting_var))
      .map(i => ({ value: i.id, label: i.title }));
  };
  console.log('formData.salaryPolicyDeductionsFormat-', formData.salaryPolicyDeductionsFormat)

  return (
    <>
      <button
        className="models-button model-add"
        title="Add Salary Details"
        onClick={handleShow}
      >
        {buffer ? <div className="spinner-vsmall"></div> : <AddwithBlueCircle />}
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="five-sixth-modal">
        <Modal.Header closeButton>
          <Modal.Title>Add Salary Structure Format</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

              <div className="form-flex-wrap">
                <div className="flex-column">
                  <label
                    htmlFor="policy_name"
                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  >
                    Format Name<span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="policy_name"
                    placeholder="Salary Policy Format Name"
                    onChange={(e) => setFormData(prev => ({
                      ...prev,
                      policy_name: e.target.value
                    }))}
                    value={formData.policy_name}
                    className={`form-input ${errors.policy_name ? "error" : inputState.policy_name ? "success" : ""}`}
                  />
                  <div>
                    {errors.policy_name && (
                      <span className="error-message font-size-text">{errors.policy_name}</span>
                    )}
                  </div>
                </div>

                {PERMISSION_AUTHORITY && (
                  <div className="flex-column form-group-select">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Sub Company<span className="required">*</span>
                    </label>
                    <br />
                    <select
                      name="sub_company"
                      onChange={(e) => setFormData(prev => ({
                        ...prev,
                        sub_company: e.target.value
                      }))}
                      value={formData.sub_company}
                      className={`form-input ${errors.sub_company ? "error" : inputState.sub_company ? "success" : ""}`}
                    >
                      <option value="">Select Sub Company</option>
                      {SUB_COMPANIES.map((company) => (
                        <option key={company.id} value={company.id}>{company.title}</option>
                      ))}
                    </select>
                    <div>
                      {errors.sub_company && (
                        <span className="error-message font-size-text">{errors.sub_company}</span>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* <div className="flex-row">
                                <label className="form-labels">
                                    Add Mode:
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        type="checkbox"
                                        id="toggle-requests"
                                        name="request_approval"
                                        checked={addMode === 'single'}
                                        onChange={() => setAddMode(addMode === 'bulk' ? 'single' : 'bulk')}
                                    />
                                    <label htmlFor="toggle-requests"></label>
                                </div>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <label className="form-labels">
                                    {addMode === 'bulk' ? 'Bulk' : 'Single'}
                                </label>
                            </div> */}

              <div>
                {errors.deductions && (
                  <span className="error-message font-size-text">{errors.deductions}</span>
                )}
              </div>
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left width-5vw">Position</th>
                    <th className="align-left width-5vw">Heading</th>
                    <th className="align-center width-5vw">Type</th>
                    <th className="align-center width-5vw">Fixed Amount</th>
                    <th className="align-center" style={{ width: '0.5vw' }}>OR</th>
                    <th className="align-center width-5vw">Percentage</th>
                    <th className="align-center width-5vw">Related To</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.salaryPolicyDeductionsFormat
                    .sort((a, b) => a.sorting_var - b.sorting_var)
                    .map((entry, index) => {
                      const heading = salaryStructureHeadings.find(t => t.id === entry.name);
                      return (
                        <React.Fragment key={index}>
                          <tr className="custom-table-head-td">
                            <td className="align-left">
                              <select
                                ref={el => inputRefs.current[index] = el}
                                name="sorting_var"
                                value={entry.sorting_var}
                                onChange={(e) => handlePositionChange(e, index)}
                                onFocus={() => handleFocus(index)}
                                onBlur={() => setFocusedInput(null)}
                                className={`form-input-date ${errors[`policy_${index}`] ? 'is-invalid' : ''}`}
                                style={{ width: '60px' }}
                              >
                                {Array.from({ length: salaryStructureHeadings.length }, (_, i) => (
                                  <option key={i + 1} value={i + 1}>
                                    {i + 1}
                                  </option>
                                ))}
                              </select>
                            </td>
                            <td className="align-left">{heading?.title || "Loading..."}</td>
                            <td className="align-center form-text-trasformation-uppercase">
                              {heading?.salary_type || "Loading..."}
                            </td>
                            <td className="align-center">
                              <div className="checkbox-toggle">
                                <input
                                  type="checkbox"
                                  id={`toggle-fixed-${index}`}
                                  checked={entry.useFixedAmount}
                                  onChange={() => {
                                    handleCheckboxChange('fixed', index);
                                    if (!entry.useFixedAmount) {
                                      setFormData(prev => {
                                        const updated = [...prev.salaryPolicyDeductionsFormat];
                                        updated[index] = {
                                          ...updated[index],
                                          usePercentage: false,
                                          percentage: '',
                                          percentage_of: []
                                        };
                                        return { ...prev, salaryPolicyDeductionsFormat: updated };
                                      });
                                    }
                                  }}
                                />
                                <label htmlFor={`toggle-fixed-${index}`}></label>
                              </div>
                            </td>
                            <td className="align-center">
                              <div style={{ width: '1vw' }} className="align-center width-5vw">OR</div>
                            </td>
                            <td
                              // colSpan={entry.usePercentage ? 1 : 2}
                              className="align-center">
                              <div className="flex-row justify-center align-center">
                                <div className="checkbox-toggle">
                                  <input
                                    type="checkbox"
                                    id={`toggle-percentage-${index}`}
                                    checked={entry.usePercentage}
                                    onChange={() => {
                                      handleCheckboxChange('percentage', index);
                                      if (!entry.usePercentage) {
                                        setFormData(prev => {
                                          const updated = [...prev.salaryPolicyDeductionsFormat];
                                          updated[index] = {
                                            ...updated[index],
                                            useFixedAmount: false,
                                            fixed_amount: ''
                                          };
                                          return { ...prev, salaryPolicyDeductionsFormat: updated };
                                        });
                                      }
                                    }}
                                  />
                                  <label htmlFor={`toggle-percentage-${index}`}></label>
                                </div>
                                {entry.usePercentage && (
                                  <input
                                    type="number"
                                    name="percentage"
                                    min={0}
                                    max={100}
                                    placeholder="0%"
                                    value={entry.percentage}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={(e) => handleInputChange(e, index)}
                                    className={`form-input-date ${errors[`policy_${index}`] ? 'is-invalid' : ''}`}
                                    style={{ width: '80px', marginLeft: '8px' }}
                                  />
                                )}
                              </div>
                            </td>
                            <td className="align-center">
                              {entry.usePercentage ? (
                                <Select
                                  isMulti
                                  name="percentage_of"
                                  value={getRelatedToOptions(index).filter(option =>
                                    entry.percentage_of?.includes(option.value)
                                  )}
                                  onChange={(selectedOptions) => handleSelectChange(selectedOptions, index)}
                                  options={getRelatedToOptions(index)}
                                  className={`width-15vw ${errors[`policy_${index}`] ? 'is-invalid' : ''}`}
                                  classNamePrefix="select"
                                  placeholder="Select Related To"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: '50px',
                                      borderRadius: '10px',
                                      border: '1px solid #e3e3e3',
                                      margin: '10px 0px 20px 0px',
                                      color: '#4a4a4a',
                                      backgroundColor: '#f7f8fa',
                                      padding: '0px 10px',
                                    }),
                                    placeholder: (provided) => ({
                                      ...provided,
                                      color: '#4a4a4a',
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      borderRadius: '10px',
                                      marginTop: '0',
                                      zIndex: 999999,
                                    }),
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 999999,
                                    }),
                                    input: (provided) => ({
                                      ...provided,
                                      color: '#4a4a4a',
                                    }),
                                    singleValue: (provided) => ({
                                      ...provided,
                                      color: '#4a4a4a',
                                    }),
                                  }}
                                />
                              ) :
                                // null
                                (
                                  <div className="flex-row justify-center">
                                    <div className="checkbox-toggle">
                                      <input
                                        type="checkbox"
                                        disabled
                                        checked={false}
                                        className="form-checkbox"
                                      />
                                      <label></label>
                                    </div>
                                  </div>
                                )
                              }
                            </td>
                          </tr>
                          {errors[`policy_${index}`] && (
                            <tr>
                              <td colSpan='7' className="align-center error-message font-size-text">
                                {errors[`policy_${index}`]}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                </tbody>
              </table>
              <div className="button-models">
                <button
                  onClick={handleSubmit}
                  className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                  disabled={loading}
                >
                  {loading ? 'Saving...' : 'Save Structure'}
                </button>
              </div>
              <br />
              <p className="error-message font-size-text">
                {isSubmitted && Object.keys(errors).length > 0 && (
                  Object.keys(errors).length > 5 ? (
                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                  ) : (

                    <h6 className="text-center">
                      {Object.keys(errors).map((field) =>
                        field.charAt(0).toUpperCase() + field.slice(1)
                      ).join(', ') + ' are required!'}
                    </h6>
                  )
                )}
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const ViewSalaryPolicyFormatDeductions = ({ i, getSalaryStructureFormat }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [sortingVarBY, setSortingVarBY] = useState(false);

  return (
    <>
      <button title="View Salary Policy Format" className="" onClick={handleShow}>
        <Eye />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="three-fourth-modal">
        <Modal.Header closeButton className="modal-header-custom">
          <div className="d-flex flex-column w-100">
            <Modal.Title className="mb-2">
              <span className="title-text">Salary Policy Format: "{i.policy_name}"</span>
            </Modal.Title>
            <div className="d-flex align-items-center ">
              <div className="checkbox-toggle">
                <input
                  type="checkbox"
                  id="View-salary-format-toggle"
                  name="show_emp_data"
                  checked={sortingVarBY}
                  onChange={() => setSortingVarBY(!sortingVarBY)}
                />
                <label htmlFor="View-salary-format-toggle"></label>
              </div>
              <hr className="field-cont-hr" />
              <div className="d-flex align-items-center">
                <label className="sort-label me-2">Sort By:</label>
                <span className="sort-method">
                  {sortingVarBY ? "Slip" : "Structure"}
                </span>
              </div>
            </div>
          </div>

        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left width-5vw">Position</th>
                    <th className="align-left width-5vw">Heading</th>
                    <th className="align-center width-5vw">Type</th>
                    <th className="align-center width-5vw">Amount</th>
                    <th className="align-center" style={{ width: '0.5vw' }}>OR</th>
                    <th className="align-center width-5vw">Percentage</th>
                    <th className="align-center width-5vw">Related To</th>
                    <th className="align-center width-5vw">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {i.custom_deductions
                    ?.sort((a, b) =>
                      sortingVarBY
                        ? a.name_sorting_var - b.name_sorting_var
                        : a.sorting_var - b.sorting_var
                    )
                    .map((deduction, index) => (
                      <tr className="custom-table-head-td" key={index}>
                        <td className="align-left">{sortingVarBY ? deduction.name_sorting_var : deduction.sorting_var}</td>
                        <td className="align-left">{deduction.name_title}</td>
                        <td className="align-center form-text-trasformation-uppercase">
                          {deduction.name_type}
                        </td>
                        <td className="align-center">
                          {/* {deduction.fixed_amount ? (Number(deduction.fixed_amount) === 0 && `Variable ${deduction.fixed_amount}`) : '-'} */}
                          {deduction.fixed_amount ? (Number(deduction.fixed_amount) === 0 && `Variable`) : '-'}
                        </td>
                        <td className="align-center">
                          <div style={{ width: '1vw' }} className="align-center width-5vw">OR</div>
                        </td>
                        <td className="align-center">
                          {deduction.percentage ?
                            `${parseFloat(deduction.percentage) % 1 === 0 ?
                              parseFloat(deduction.percentage).toFixed(0)
                              : parseFloat(deduction.percentage).toFixed(2)}%`
                            : '-'}
                        </td>
                        <td className="align-lefTt width-10vw">
                          {deduction.percentage_of.length === 0 ?
                            <div className="align-center">-</div> :
                            <ul style={{ paddingLeft: '0' }}>
                              {deduction.percentage_of.map((data, idx) => (
                                <li key={idx}>
                                  <span className="form-text-trasformation-uppercase">
                                    {data.name_title}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          }
                        </td>
                        <td className="align-center ">
                          <div className="flex-row ">
                            <UpdateCustomDeductionPolicy
                              i={deduction}
                              deductionData={i.custom_deductions}
                              sub_company={i.sub_company}
                              getSalaryStructureFormat={getSalaryStructureFormat}
                            />
                            <DeleteCustomDeductionPolicy
                              i={deduction}
                              getSalaryStructureFormat={getSalaryStructureFormat}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

const DeleteSalaryStructurePolicyFormat = ({ i, getSalaryStructureFormat }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = async () => setShow(true);

  const [sortingVarBY, setSortingVarBY] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmitDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      const res = await axios.delete(`${BASE_URL}/siteproject/salarypolicy/${i.id}/`);

      if (res.status === 200 || res.status === 201) {
        toast.success("Salary Format Deleted Successfully.");
        getSalaryStructureFormat();
        handleClose();
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };



  return (
    <>
      <button title="Delete Salary Format" onClick={handleShow} className="model-delete-button">
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header closeButton>
          <Modal.Title>Delete Salary Structure Format</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete salary structure format "{i.policy_name}"

            <div className="button-models">
              <button className="model-button font-weight500 model-button-cancel" onClick={handleClose}>
                Cancel
              </button>
              <button
                onClick={handleSubmitDelete}
                className="model-button font-weight500 model-button-delete"
                disabled={loading}
              >
                {loading ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};


const UpdateCustomDeductionPolicy = ({ i, deductionData, sub_company, getSalaryStructureFormat }) => {
  const [formData, setFormData] = useState({
    name: i.id,
    salary_policy: "",
    salary_type: i.salary_type,
    percentage: '',
    percentage_of: [],
    fixed_amount: '',
  });
  const [show, setShow] = useState(false);
  const [buffer, setBuffering] = useState(false);
  const [selectedPercentageOf, setSelectedPercentageOf] = useState([]);
  const [salaryStructureHeadings, setSalaryStructureHeadings] = useState([]);

  const handleShow = () => {
    getAllSalaryRelatedData();

    const transformedData = {
      ...i,
      percentage_of: Array.isArray(i.percentage_of) ? i.percentage_of.map(item => ({
        value: item.name_title,
        label: item.name_title,
      })) : [],
    };

    setFormData(transformedData);
    setSelectedPercentageOf(transformedData.percentage_of);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const getAllSalaryRelatedData = async () => {
    setBuffering(true);
    try {
      const headings = await axios.get(`${BASE_URL}/siteproject/salaryHeadingbysubcompany/${sub_company}/`);
      setSalaryStructureHeadings(headings.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  const [inputState, setInputState] = useState({});
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSelectChange = (selectedOptions) => {
    setSelectedPercentageOf(selectedOptions);
    setFormData({
      ...formData,
      percentage_of: selectedOptions ? selectedOptions.map(option => ({
        value: option.value,
        label: option.label
      })) : [],
    });
  };

  const [loading, setLoading] = useState(false);
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    const updatedFormData = {
      ...formData,
      percentage_of: formData.percentage_of.map(item => item.label),
    };

    try {
      let ress = await axios.put(`${BASE_URL}/siteproject/customdeductionpolicyupdate/${i.id}/`, updatedFormData);
      if (ress.status === 200 || ress.status === 201) {
        toast.success("Updated Deduction");
        // await getAllSalaryRelatedData();
        await getSalaryStructureFormat();
        handleClose();
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  // Get current item's sorting_var
  const currentItem = deductionData.find(item => item.id === i.id);
  const currentSortingVar = currentItem?.sorting_var || 0;

  // Filter options based on sorting_var
  const relatedToOptionsnew = deductionData
    .filter(item => {
      // Exclude current item
      if (item.id === i.id) return false;

      // Only include items with sorting_var less than current item
      return item.sorting_var < currentSortingVar;
    })
    .sort((a, b) => a.sorting_var - b.sorting_var)
    .map(item => {
      // Find the corresponding heading for display name
      const heading = salaryStructureHeadings.find(h => h.id === item.name);
      return {
        value: heading?.title || item.name,
        label: heading?.title || item.name
      };
    });

  const relatedToOptions = deductionData
    .filter(item => item.id !== formData.id)
    .filter(item => Number(item.sorting_var) < Number(formData.sorting_var))
    .sort((a, b) => a.sorting_var - b.sorting_var)
    .map(i => ({ value: i.name_title, label: i.name_title }));


  // console.log('relatedToOptions-1', relatedToOptions)
  // console.log('formData-1', formData)
  // console.log('deductionData-1', deductionData)
  // console.log('salaryStructureHeadings-1', salaryStructureHeadings)
  return (
    <div>
      <>
        <button title='Update Deduction' className='model-edit-button' onClick={handleShow}>
          <UpdatePencil />
        </button>
        <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
          <Modal.Header closeButton>
            <Modal.Title>Update Deduction of : "{salaryStructureHeadings?.find(t => t.id === formData.name)?.title} ({salaryStructureHeadings?.find(t => t.id === formData.name)?.salary_type})"</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
            <form className="register-form">
              <div className="">
                {formData.percentage || formData.percentage_of.length > 0 ? "" :
                  <div className="flex-column">
                    <label className="form-labels  font-weight500 font-size-subheading">Fixed Amount<span className="required">*</span></label>
                    <input
                      type="number"
                      name="fixed_amount"
                      placeholder="Fixed Amount"
                      min={0}
                      value={formData.fixed_amount}
                      onChange={handleInputChange}
                      className={`form-input ${errors.fixed_amount ? 'is-invalid' : ''}`}
                    />
                    {errors.fixed_amount && <div className="error-message font-size-text">{errors.fixed_amount}</div>}
                  </div>
                }
                {formData.fixed_amount ? "" :
                  <>
                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">Percentage of Amount<span className="required">*</span></label>
                      <input
                        type="number"
                        name="percentage"
                        placeholder="Percentage of Amount"
                        min={0}
                        value={formData.percentage}
                        onChange={handleInputChange}
                        className={`form-input ${errors.percentage ? 'is-invalid' : ''}`}
                      />
                      {errors.percentage && <div className="error-message font-size-text">{errors.percentage}</div>}
                    </div>
                    <div title="Related To" className="flex-column ">
                      <label className="form-labels  font-weight500 font-size-subheading">Related To<span className="required">*</span></label>
                      <Select
                        isMulti
                        name="percentage_of"
                        value={selectedPercentageOf}
                        onChange={handleSelectChange}
                        options={relatedToOptions}
                        className={`width-15vw ${errors.percentage_of ? 'is-invalid' : ''}`}
                        classNamePrefix="select"
                        placeholder="Select Related To"
                        isDisabled={!!formData.fixed_amount}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            width: '33vw',
                            minHeight: '50px',
                            borderRadius: '10px',
                            border: '1px solid #e3e3e3',
                            margin: '10px 0px 20px 0px',
                            color: '#4a4a4a',
                            backgroundColor: '#f7f8fa',
                            padding: '0px 10px',
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: '#4a4a4a',
                          }),
                          menu: (provided) => ({
                            ...provided,
                            width: '33vw',
                            borderRadius: '10px',
                            marginTop: '0',
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            color: '#4a4a4a',
                          }),
                          input: (provided) => ({
                            ...provided,
                            color: '#4a4a4a',
                          }),
                        }}
                      />
                      {errors.percentage_of && <div className="error-message font-size-text">{errors.percentage_of}</div>}
                    </div>
                  </>
                }
              </div>
            </form>
            {errors.mixed && <div className="error-message font-size-text">{errors.mixed}</div>}
            <div className="button-models">
              <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
                Cancel
              </button>
              <button className="model-button  font-weight500  model-button-leave font-size-heading" onClick={handleFormSubmit} disabled={loading}>
                {loading ? 'Updating...' : 'Update'}
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </>
    </div>
  );
};

const DeleteCustomDeductionPolicy = ({ i, deductionData, getSalaryStructureFormat }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      let response = await axios.delete(`${BASE_URL}/siteproject/customdeductionpolicyupdate/${i.id}/`);
      if (response.status === 200 || response.status === 201) {
        toast.success("Deleted Deduction Successfully");
        await getSalaryStructureFormat();
        handleClose();
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button title='Delete Deduction' className='model-delete-button' onClick={handleShow}>
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header closeButton>
          <Modal.Title>Delete Custom Deduction: "{i.name_title}"</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
          <form className="register-form">
            <div className="">
              {i.percentage || i.percentage_of?.length > 0 ? "" :
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading">Amount:</label>
                  <div className='form-labels justify-center'>
                    {/* {i?.fixed_amount} */}
                    Variable
                  </div>
                </div>
              }
              {i.fixed_amount ? "" :
                <>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">Percentage:</label>
                    <div className='form-labels justify-center'>
                      {i?.percentage}%
                    </div>
                  </div>
                  <div title="Related To" className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading">Related To:</label>
                    <ul>
                      {i?.percentage_of?.map((item, index) => (
                        <li key={index}>
                          {item?.name_title}
                        </li>
                      ))}
                    </ul>
                  </div>
                </>
              }
            </div>
          </form>
          <div className="button-models">
            <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
              Cancel
            </button>
            <button
              className="model-button font-weight500 model-button-delete font-size-heading"
              onClick={handleFormSubmit}
              disabled={loading}
            >
              {loading ? 'Deleting...' : 'Delete'}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

// ? *************** SalaryDeductionPolicy Crud Models End ***************



export {
  UploadSalaryDataBulk,
  UpdateSalaryDataBulk,
  RunPayRoll,

  SalaryStructureHeadingAdd,
  SalaryStructureHeadingUpdate,
  SalaryStructureHeadingDelete,

  EmployeeSalaryStructure,
  PayrollSalaryStructureFormat,
  // UserCustomDeductions,
  // AddCustomDeductions,
  // DeleteCustomDeductions,

  SalaryDeductionPolicyAdd,
  SalaryDeductionPolicyUpdate,
  SalaryDeductionPolicyDelete,


  AddSalaryStructurePolicyFormat,
  ViewSalaryPolicyFormatDeductions,
  DeleteSalaryStructurePolicyFormat,
  UpdateCustomDeductionPolicy,
  DeleteCustomDeductionPolicy,
};
